import * as Do from "vue";
import { defineComponent as $t, h as Zn, getCurrentScope as El, onScopeDispose as kl, inject as xl, onMounted as mr, onUnmounted as Cl, Fragment as In, computed as Ye, watch as zo, ref as Ve, shallowRef as Al, createVNode as Ko, Text as Ll, openBlock as X, createElementBlock as te, createElementVNode as _, toDisplayString as I, unref as P, createTextVNode as Lt, renderList as fr, reactive as ea, normalizeClass as on, createCommentVNode as Ue, withModifiers as Tl, withDirectives as Mo, vModelText as Ro, normalizeProps as Nl, guardReactiveProps as Ol, createBlock as Pl } from "vue";
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function pt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const os = {};
function Il(e) {
  os[e] || (os[e] = !0, pt(e));
}
const Ct = typeof window < "u";
let We, Kt;
if (process.env.NODE_ENV !== "production") {
  const e = Ct && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (We = (t) => {
    e.mark(t);
  }, Kt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Sl = /\{([0-9a-zA-Z]+)\}/g;
function yo(e, ...t) {
  return t.length === 1 && Z(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Sl, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const At = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), $l = (e, t, n) => Dl({ l: e, k: t, s: n }), Dl = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Te = (e) => typeof e == "number" && isFinite(e), ta = (e) => pr(e) === "[object Date]", Jn = (e) => pr(e) === "[object RegExp]", _o = (e) => ie(e) && Object.keys(e).length === 0, Ce = Object.assign, Ml = Object.create, ce = (e = null) => Ml(e);
let rs;
const Yt = () => rs || (rs = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : ce());
function ss(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Rl(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const Bl = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, Fl = /^(?:href|src|action|formaction)$/i;
function wr(e) {
  return Bl.test(e);
}
function Ul(e) {
  const t = /url\s*\(/gi;
  let n = "", o = 0, r;
  for (; (r = t.exec(e)) !== null; ) {
    const s = r.index, a = t.lastIndex - 1;
    let l = a + 1, i = 1, w = null;
    for (; l < e.length; l++) {
      const d = e[l];
      if (w) {
        d === w && (w = null);
        continue;
      }
      if (d === '"' || d === "'")
        w = d;
      else if (d === "(")
        i++;
      else if (d === ")" && (i--, i === 0))
        break;
    }
    if (i !== 0)
      break;
    const g = e.slice(a + 1, l).trim(), E = g.startsWith('"') && g.endsWith('"') || g.startsWith("'") && g.endsWith("'") ? g.slice(1, -1).trim() : g;
    n += e.slice(o, s), n += wr(E) ? "url(about:blank)" : e.slice(s, l + 1), o = l + 1;
  }
  return n + e.slice(o);
}
function as(e, t) {
  if (Fl.test(e) && wr(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? Ul(t) : t;
  return Rl(n);
}
function Vl(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, o, r) => `${o}="${as(o, r)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, o, r) => `${o}='${as(o, r)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && pt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, o, r) => wr(r) ? `${o}about:blank` : n), e;
}
const Hl = Object.prototype.hasOwnProperty;
function nt(e, t) {
  return Hl.call(e, t);
}
const ye = Array.isArray, fe = (e) => typeof e == "function", B = (e) => typeof e == "string", ve = (e) => typeof e == "boolean", Z = (e) => e !== null && typeof e == "object", jl = (e) => Z(e) && fe(e.then) && fe(e.catch), na = Object.prototype.toString, pr = (e) => na.call(e), ie = (e) => pr(e) === "[object Object]", Yl = (e) => e == null ? "" : ye(e) || ie(e) && e.toString === na ? JSON.stringify(e, null, 2) : String(e);
function hr(e, t = "") {
  return e.reduce((n, o, r) => r === 0 ? n + o : n + t + o, "");
}
const is = 2;
function Wl(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let a = 0; a < o.length; a++)
    if (r += o[a].length + 1, r >= t) {
      for (let l = a - is; l <= a + is || n > r; l++) {
        if (l < 0 || l >= o.length)
          continue;
        const i = l + 1;
        s.push(`${i}${" ".repeat(3 - String(i).length)}|  ${o[l]}`);
        const w = o[l].length;
        if (l === a) {
          const g = t - (r - w) + 1, E = Math.max(1, n > r ? w - g : n - t);
          s.push("   |  " + " ".repeat(g) + "^".repeat(E));
        } else if (l > a) {
          if (n > r) {
            const g = Math.max(Math.min(n - r, w), 1);
            s.push("   |  " + "^".repeat(g));
          }
          r += w + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function oa() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const r = e.get(n);
      r && r.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const r = e.get(n);
      r && r.splice(r.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((r) => r(o)), (e.get("*") || []).slice().map((r) => r(n, o));
    }
  };
}
const Wn = (e) => !Z(e) || ye(e);
function Xn(e, t) {
  if (Wn(e) || Wn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: r } = n.pop();
    Object.keys(o).forEach((s) => {
      s !== "__proto__" && (Z(o[s]) && !Z(r[s]) && (r[s] = Array.isArray(o[s]) ? [] : ce()), Wn(r[s]) || Wn(o[s]) ? r[s] = o[s] : n.push({ src: o[s], des: r[s] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function ql(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Go(e, t, n) {
  return { start: e, end: t };
}
const z = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, zl = 17, Kl = {
  // tokenizer error messages
  [z.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [z.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [z.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [z.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [z.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [z.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [z.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [z.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [z.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [z.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [z.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [z.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [z.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [z.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [z.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [z.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function pn(e, t, n = {}) {
  const { domain: o, messages: r, args: s } = n, a = process.env.NODE_ENV !== "production" ? yo((r || Kl)[e] || "", ...s || []) : e, l = new SyntaxError(String(a));
  return l.code = e, t && (l.location = t), l.domain = o, l;
}
function Gl(e) {
  throw e;
}
const Xl = /<\/?[\w\s="/.':;#-\/]+>/, Zl = (e) => Xl.test(e), ut = " ", Jl = "\r", Ie = `
`, Ql = "\u2028", ec = "\u2029";
function tc(e) {
  const t = e;
  let n = 0, o = 1, r = 1, s = 0;
  const a = (x) => t[x] === Jl && t[x + 1] === Ie, l = (x) => t[x] === Ie, i = (x) => t[x] === ec, w = (x) => t[x] === Ql, g = (x) => a(x) || l(x) || i(x) || w(x), E = () => n, d = () => o, h = () => r, C = () => s, p = (x) => a(x) || i(x) || w(x) ? Ie : t[x], T = () => p(n), f = () => p(n + s);
  function b() {
    return s = 0, g(n) && (o++, r = 0), a(n) && n++, n++, r++, t[n];
  }
  function A() {
    return a(n + s) && s++, s++, t[n + s];
  }
  function m() {
    n = 0, o = 1, r = 1, s = 0;
  }
  function L(x = 0) {
    s = x;
  }
  function S() {
    const x = n + s;
    for (; x !== n; )
      b();
    s = 0;
  }
  return {
    index: E,
    line: d,
    column: h,
    peekOffset: C,
    charAt: p,
    currentChar: T,
    currentPeek: f,
    next: b,
    peek: A,
    reset: m,
    resetPeek: L,
    skipToPeek: S
  };
}
const yt = void 0, nc = ".", ls = "'", oc = "tokenizer";
function rc(e, t = {}) {
  const n = t.location !== !1, o = tc(e), r = () => o.index(), s = () => ql(o.line(), o.column(), o.index()), a = s(), l = r(), i = {
    currentType: 13,
    offset: l,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: l,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, w = () => i, { onError: g } = t;
  function E(c, u, N, ...R) {
    const me = w();
    if (u.column += N, u.offset += N, g) {
      const he = n ? Go(me.startLoc, u) : null, Q = pn(c, he, {
        domain: oc,
        args: R
      });
      g(Q);
    }
  }
  function d(c, u, N) {
    c.endLoc = s(), c.currentType = u;
    const R = { type: u };
    return n && (R.loc = Go(c.startLoc, c.endLoc)), N != null && (R.value = N), R;
  }
  const h = (c) => d(
    c,
    13
    /* TokenTypes.EOF */
  );
  function C(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (E(z.EXPECTED_TOKEN, s(), 0, u), "");
  }
  function p(c) {
    let u = "";
    for (; c.currentPeek() === ut || c.currentPeek() === Ie; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function T(c) {
    const u = p(c);
    return c.skipToPeek(), u;
  }
  function f(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function b(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function A(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    p(c);
    const R = f(c.currentPeek());
    return c.resetPeek(), R;
  }
  function m(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    p(c);
    const R = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), me = b(R);
    return c.resetPeek(), me;
  }
  function L(c, u) {
    const { currentType: N } = u;
    if (N !== 2)
      return !1;
    p(c);
    const R = c.currentPeek() === ls;
    return c.resetPeek(), R;
  }
  function S(c, u) {
    const { currentType: N } = u;
    if (N !== 7)
      return !1;
    p(c);
    const R = c.currentPeek() === ".";
    return c.resetPeek(), R;
  }
  function x(c, u) {
    const { currentType: N } = u;
    if (N !== 8)
      return !1;
    p(c);
    const R = f(c.currentPeek());
    return c.resetPeek(), R;
  }
  function K(c, u) {
    const { currentType: N } = u;
    if (!(N === 7 || N === 11))
      return !1;
    p(c);
    const R = c.currentPeek() === ":";
    return c.resetPeek(), R;
  }
  function Y(c, u) {
    const { currentType: N } = u;
    if (N !== 9)
      return !1;
    const R = () => {
      const he = c.currentPeek();
      return he === "{" ? f(c.peek()) : he === "@" || he === "|" || he === ":" || he === "." || he === ut || !he ? !1 : he === Ie ? (c.peek(), R()) : W(c, !1);
    }, me = R();
    return c.resetPeek(), me;
  }
  function H(c) {
    p(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function W(c, u = !0) {
    const N = (me = !1, he = "") => {
      const Q = c.currentPeek();
      return Q === "{" || Q === "@" || !Q ? me : Q === "|" ? !(he === ut || he === Ie) : Q === ut ? (c.peek(), N(!0, ut)) : Q === Ie ? (c.peek(), N(!0, Ie)) : !0;
    }, R = N();
    return u && c.resetPeek(), R;
  }
  function ne(c, u) {
    const N = c.currentChar();
    return N === yt ? yt : u(N) ? (c.next(), N) : null;
  }
  function Je(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function q(c) {
    return ne(c, Je);
  }
  function M(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function $(c) {
    return ne(c, M);
  }
  function V(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function D(c) {
    return ne(c, V);
  }
  function G(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function j(c) {
    return ne(c, G);
  }
  function J(c) {
    let u = "", N = "";
    for (; u = D(c); )
      N += u;
    return N;
  }
  function de(c) {
    let u = "";
    for (; ; ) {
      const N = c.currentChar();
      if (N === "\\") {
        const R = c.peek();
        R === "{" || R === "}" || R === "@" || R === "|" || R === "\\" ? (u += N + R, c.next(), c.next()) : (c.resetPeek(), u += N, c.next());
      } else {
        if (N === "{" || N === "}" || N === "@" || N === "|" || !N)
          break;
        if (N === ut || N === Ie)
          if (W(c))
            u += N, c.next();
          else {
            if (H(c))
              break;
            u += N, c.next();
          }
        else
          u += N, c.next();
      }
    }
    return u;
  }
  function we(c) {
    T(c);
    let u = "", N = "";
    for (; u = $(c); )
      N += u;
    const R = c.currentChar();
    if (R && R !== "}" && R !== yt && R !== ut && R !== Ie && R !== "　") {
      const me = xe(c);
      return E(z.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, N + me), N + me;
    }
    return c.currentChar() === yt && E(z.UNTERMINATED_CLOSING_BRACE, s(), 0), N;
  }
  function ke(c) {
    T(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${J(c)}`) : u += J(c), c.currentChar() === yt && E(z.UNTERMINATED_CLOSING_BRACE, s(), 0), u;
  }
  function Pe(c) {
    return c !== ls && c !== Ie;
  }
  function bt(c) {
    T(c), C(c, "'");
    let u = "", N = "";
    for (; u = ne(c, Pe); )
      u === "\\" ? N += st(c) : N += u;
    const R = c.currentChar();
    return R === Ie || R === yt ? (E(z.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), R === Ie && (c.next(), C(c, "'")), N) : (C(c, "'"), N);
  }
  function st(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return lt(c, u, 4);
      case "U":
        return lt(c, u, 6);
      default:
        return E(z.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, u), "";
    }
  }
  function lt(c, u, N) {
    C(c, u);
    let R = "";
    for (let me = 0; me < N; me++) {
      const he = j(c);
      if (!he) {
        E(z.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${u}${R}${c.currentChar()}`);
        break;
      }
      R += he;
    }
    return `\\${u}${R}`;
  }
  function at(c) {
    return c !== "{" && c !== "}" && c !== ut && c !== Ie;
  }
  function xe(c) {
    T(c);
    let u = "", N = "";
    for (; u = ne(c, at); )
      N += u;
    return N;
  }
  function Qe(c) {
    let u = "", N = "";
    for (; u = q(c); )
      N += u;
    return N;
  }
  function vt(c) {
    const u = (N) => {
      const R = c.currentChar();
      return R === "{" || R === "@" || R === "|" || R === "(" || R === ")" || !R || R === ut ? N : (N += R, c.next(), u(N));
    };
    return u("");
  }
  function ct(c) {
    T(c);
    const u = C(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return T(c), u;
  }
  function xn(c, u) {
    let N = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && E(z.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), c.next(), N = d(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), T(c), u.braceNest++, N;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && E(z.EMPTY_PLACEHOLDER, s(), 0), c.next(), N = d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && T(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), N;
      case "@":
        return u.braceNest > 0 && E(z.UNTERMINATED_CLOSING_BRACE, s(), 0), N = Bt(c, u) || h(u), u.braceNest = 0, N;
      default: {
        let me = !0, he = !0, Q = !0;
        if (H(c))
          return u.braceNest > 0 && E(z.UNTERMINATED_CLOSING_BRACE, s(), 0), N = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, N;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return E(z.UNTERMINATED_CLOSING_BRACE, s(), 0), u.braceNest = 0, Cn(c, u);
        if (me = A(c, u))
          return N = d(u, 4, we(c)), T(c), N;
        if (he = m(c, u))
          return N = d(u, 5, ke(c)), T(c), N;
        if (Q = L(c, u))
          return N = d(u, 6, bt(c)), T(c), N;
        if (!me && !he && !Q)
          return N = d(u, 12, xe(c)), E(z.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, N.value), T(c), N;
        break;
      }
    }
    return N;
  }
  function Bt(c, u) {
    const { currentType: N } = u;
    let R = null;
    const me = c.currentChar();
    switch ((N === 7 || N === 8 || N === 11 || N === 9) && (me === Ie || me === ut) && E(z.INVALID_LINKED_FORMAT, s(), 0), me) {
      case "@":
        return c.next(), R = d(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, R;
      case ".":
        return T(c), c.next(), d(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return T(c), c.next(), d(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return H(c) ? (R = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, R) : S(c, u) || K(c, u) ? (T(c), Bt(c, u)) : x(c, u) ? (T(c), d(u, 11, Qe(c))) : Y(c, u) ? (T(c), me === "{" ? xn(c, u) || R : d(u, 10, vt(c))) : (N === 7 && E(z.INVALID_LINKED_FORMAT, s(), 0), u.braceNest = 0, u.inLinked = !1, Cn(c, u));
    }
  }
  function Cn(c, u) {
    let N = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return xn(c, u) || h(u);
    if (u.inLinked)
      return Bt(c, u) || h(u);
    switch (c.currentChar()) {
      case "{":
        return xn(c, u) || h(u);
      case "}":
        return E(z.UNBALANCED_CLOSING_BRACE, s(), 0), c.next(), d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Bt(c, u) || h(u);
      default: {
        if (H(c))
          return N = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, N;
        if (W(c))
          return d(u, 0, de(c));
        break;
      }
    }
    return N;
  }
  function $o() {
    const { currentType: c, offset: u, startLoc: N, endLoc: R } = i;
    return i.lastType = c, i.lastOffset = u, i.lastStartLoc = N, i.lastEndLoc = R, i.offset = r(), i.startLoc = s(), o.currentChar() === yt ? d(
      i,
      13
      /* TokenTypes.EOF */
    ) : Cn(o, i);
  }
  return {
    nextToken: $o,
    currentOffset: r,
    currentPosition: s,
    context: w
  };
}
const sc = "parser", ac = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, ic = /\\([\\@{}|])/g;
function lc(e, t) {
  return t;
}
function cc(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function uc(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(f, b, A, m, ...L) {
    const S = f.currentPosition();
    if (S.offset += m, S.column += m, n) {
      const x = t ? Go(A, S) : null, K = pn(b, x, {
        domain: sc,
        args: L
      });
      n(K);
    }
  }
  function r(f, b, A) {
    const m = { type: f };
    return t && (m.start = b, m.end = b, m.loc = { start: A, end: A }), m;
  }
  function s(f, b, A, m) {
    t && (f.end = b, f.loc && (f.loc.end = A));
  }
  function a(f, b) {
    const A = f.context(), m = r(3, A.offset, A.startLoc);
    return m.value = b.replace(ic, lc), s(m, f.currentOffset(), f.currentPosition()), m;
  }
  function l(f, b) {
    const A = f.context(), { lastOffset: m, lastStartLoc: L } = A, S = r(5, m, L);
    return S.index = parseInt(b, 10), f.nextToken(), s(S, f.currentOffset(), f.currentPosition()), S;
  }
  function i(f, b) {
    const A = f.context(), { lastOffset: m, lastStartLoc: L } = A, S = r(4, m, L);
    return S.key = b, f.nextToken(), s(S, f.currentOffset(), f.currentPosition()), S;
  }
  function w(f, b) {
    const A = f.context(), { lastOffset: m, lastStartLoc: L } = A, S = r(9, m, L);
    return S.value = b.replace(ac, cc), f.nextToken(), s(S, f.currentOffset(), f.currentPosition()), S;
  }
  function g(f) {
    const b = f.nextToken(), A = f.context(), { lastOffset: m, lastStartLoc: L } = A, S = r(8, m, L);
    return b.type !== 11 ? (o(f, z.UNEXPECTED_EMPTY_LINKED_MODIFIER, A.lastStartLoc, 0), S.value = "", s(S, m, L), {
      nextConsumeToken: b,
      node: S
    }) : (b.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, A.lastStartLoc, 0, dt(b)), S.value = b.value || "", s(S, f.currentOffset(), f.currentPosition()), {
      node: S
    });
  }
  function E(f, b) {
    const A = f.context(), m = r(7, A.offset, A.startLoc);
    return m.value = b, s(m, f.currentOffset(), f.currentPosition()), m;
  }
  function d(f) {
    const b = f.context(), A = r(6, b.offset, b.startLoc);
    let m = f.nextToken();
    if (m.type === 8) {
      const L = g(f);
      A.modifier = L.node, m = L.nextConsumeToken || f.nextToken();
    }
    switch (m.type !== 9 && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(m)), m = f.nextToken(), m.type === 2 && (m = f.nextToken()), m.type) {
      case 10:
        m.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(m)), A.key = E(f, m.value || "");
        break;
      case 4:
        m.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(m)), A.key = i(f, m.value || "");
        break;
      case 5:
        m.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(m)), A.key = l(f, m.value || "");
        break;
      case 6:
        m.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(m)), A.key = w(f, m.value || "");
        break;
      default: {
        o(f, z.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const L = f.context(), S = r(7, L.offset, L.startLoc);
        return S.value = "", s(S, L.offset, L.startLoc), A.key = S, s(A, L.offset, L.startLoc), {
          nextConsumeToken: m,
          node: A
        };
      }
    }
    return s(A, f.currentOffset(), f.currentPosition()), {
      node: A
    };
  }
  function h(f) {
    const b = f.context(), A = b.currentType === 1 ? f.currentOffset() : b.offset, m = b.currentType === 1 ? b.endLoc : b.startLoc, L = r(2, A, m);
    L.items = [];
    let S = null;
    do {
      const Y = S || f.nextToken();
      switch (S = null, Y.type) {
        case 0:
          Y.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(Y)), L.items.push(a(f, Y.value || ""));
          break;
        case 5:
          Y.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(Y)), L.items.push(l(f, Y.value || ""));
          break;
        case 4:
          Y.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(Y)), L.items.push(i(f, Y.value || ""));
          break;
        case 6:
          Y.value == null && o(f, z.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, dt(Y)), L.items.push(w(f, Y.value || ""));
          break;
        case 7: {
          const H = d(f);
          L.items.push(H.node), S = H.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 13 && b.currentType !== 1);
    const x = b.currentType === 1 ? b.lastOffset : f.currentOffset(), K = b.currentType === 1 ? b.lastEndLoc : f.currentPosition();
    return s(L, x, K), L;
  }
  function C(f, b, A, m) {
    const L = f.context();
    let S = m.items.length === 0;
    const x = r(1, b, A);
    x.cases = [], x.cases.push(m);
    do {
      const K = h(f);
      S || (S = K.items.length === 0), x.cases.push(K);
    } while (L.currentType !== 13);
    return S && o(f, z.MUST_HAVE_MESSAGES_IN_PLURAL, A, 0), s(x, f.currentOffset(), f.currentPosition()), x;
  }
  function p(f) {
    const b = f.context(), { offset: A, startLoc: m } = b, L = h(f);
    return b.currentType === 13 ? L : C(f, A, m, L);
  }
  function T(f) {
    const b = rc(f, Ce({}, e)), A = b.context(), m = r(0, A.offset, A.startLoc);
    return t && m.loc && (m.loc.source = f), m.body = p(b), e.onCacheKey && (m.cacheKey = e.onCacheKey(f)), A.currentType !== 13 && o(b, z.UNEXPECTED_LEXICAL_ANALYSIS, A.lastStartLoc, 0, f[A.offset] || ""), s(m, b.currentOffset(), b.currentPosition()), m;
  }
  return { parse: T };
}
function dt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function dc(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function cs(e, t) {
  for (let n = 0; n < e.length; n++)
    gr(e[n], t);
}
function gr(e, t) {
  switch (e.type) {
    case 1:
      cs(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      cs(e.items, t);
      break;
    case 6: {
      gr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function mc(e, t = {}) {
  const n = dc(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && gr(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function fc(e) {
  const t = e.body;
  return t.type === 2 ? us(t) : t.cases.forEach((n) => us(n)), e;
}
function us(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = hr(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const wc = "minifier";
function nn(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      nn(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        nn(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        nn(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      nn(t.key), t.k = t.key, delete t.key, t.modifier && (nn(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw pn(z.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: wc,
          args: [e.type]
        });
  }
  delete e.type;
}
const pc = "parser";
function hc(e, t) {
  const { filename: n, breakLineCode: o, needIndent: r } = t, s = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: r,
    indentLevel: 0
  };
  s && e.loc && (a.source = e.loc.source);
  const l = () => a;
  function i(p, T) {
    a.code += p;
  }
  function w(p, T = !0) {
    const f = T ? o : "";
    i(r ? f + "  ".repeat(p) : f);
  }
  function g(p = !0) {
    const T = ++a.indentLevel;
    p && w(T);
  }
  function E(p = !0) {
    const T = --a.indentLevel;
    p && w(T);
  }
  function d() {
    w(a.indentLevel);
  }
  return {
    context: l,
    push: i,
    indent: g,
    deindent: E,
    newline: d,
    helper: (p) => `_${p}`,
    needIndent: () => a.needIndent
  };
}
function gc(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), cn(e, t.key), t.modifier ? (e.push(", "), cn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function bc(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const r = t.items.length;
  for (let s = 0; s < r && (cn(e, t.items[s]), s !== r - 1); s++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function vc(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const r = t.cases.length;
    for (let s = 0; s < r && (cn(e, t.cases[s]), s !== r - 1); s++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function yc(e, t) {
  t.body ? cn(e, t.body) : e.push("null");
}
function cn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      yc(e, t);
      break;
    case 1:
      vc(e, t);
      break;
    case 2:
      bc(e, t);
      break;
    case 6:
      gc(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw pn(z.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: pc,
          args: [t.type]
        });
  }
}
const _c = (e, t = {}) => {
  const n = B(t.mode) ? t.mode : "normal", o = B(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], l = hc(e, {
    filename: o,
    breakLineCode: r,
    needIndent: s
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(s), a.length > 0 && (l.push(`const { ${hr(a.map((g) => `${g}: _${g}`), ", ")} } = ctx`), l.newline()), l.push("return "), cn(l, e), l.deindent(s), l.push("}"), delete e.helpers;
  const { code: i, map: w } = l.context();
  return {
    ast: e,
    code: i,
    map: w ? w.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ec(e, t = {}) {
  const n = Ce({}, t), o = !!n.jit, r = !!n.minify, s = n.optimize == null ? !0 : n.optimize, l = uc(n).parse(e);
  return o ? (s && fc(l), r && nn(l), { ast: l, code: "" }) : (mc(l, n), _c(l, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function kc() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Yt().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Yt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function it(e) {
  return Z(e) && br(e) === 0 && (nt(e, "b") || nt(e, "body"));
}
const ra = ["b", "body"];
function xc(e) {
  return Dt(e, ra);
}
const sa = ["c", "cases"];
function Cc(e) {
  return Dt(e, sa, []);
}
const aa = ["s", "static"];
function Ac(e) {
  return Dt(e, aa);
}
const ia = ["i", "items"];
function Lc(e) {
  return Dt(e, ia, []);
}
const la = ["t", "type"];
function br(e) {
  return Dt(e, la);
}
const ca = ["v", "value"];
function qn(e, t) {
  const n = Dt(e, ca);
  if (n != null)
    return n;
  throw Ln(t);
}
const ua = ["m", "modifier"];
function Tc(e) {
  return Dt(e, ua);
}
const da = ["k", "key"];
function Nc(e) {
  const t = Dt(e, da);
  if (t)
    return t;
  throw Ln(
    6
    /* NodeTypes.Linked */
  );
}
function Dt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (nt(e, r) && e[r] != null)
      return e[r];
  }
  return n;
}
const ma = [
  ...ra,
  ...sa,
  ...aa,
  ...ia,
  ...da,
  ...ua,
  ...ca,
  ...la
];
function Ln(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Bo(e) {
  return (n) => Oc(n, e);
}
function Oc(e, t) {
  const n = xc(t);
  if (n == null)
    throw Ln(
      0
      /* NodeTypes.Resource */
    );
  if (br(n) === 1) {
    const s = Cc(n);
    return e.plural(s.reduce((a, l) => [
      ...a,
      ds(e, l)
    ], []));
  } else
    return ds(e, n);
}
function ds(e, t) {
  const n = Ac(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = Lc(t).reduce((r, s) => [...r, Xo(e, s)], []);
    return e.normalize(o);
  }
}
function Xo(e, t) {
  const n = br(t);
  switch (n) {
    case 3:
      return qn(t, n);
    case 9:
      return qn(t, n);
    case 4: {
      const o = t;
      if (nt(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (nt(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Ln(n);
    }
    case 5: {
      const o = t;
      if (nt(o, "i") && Te(o.i))
        return e.interpolate(e.list(o.i));
      if (nt(o, "index") && Te(o.index))
        return e.interpolate(e.list(o.index));
      throw Ln(n);
    }
    case 6: {
      const o = t, r = Tc(o), s = Nc(o);
      return e.linked(Xo(e, s), r ? Xo(e, r) : void 0, e.type);
    }
    case 7:
      return qn(t, n);
    case 8:
      return qn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const Pc = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Ic(e, t) {
  t && Zl(e) && pt(yo(Pc, { source: e }));
}
const Sc = (e) => e;
let zn = ce();
function $c(e, t = {}) {
  let n = !1;
  const o = t.onError || Gl;
  return t.onError = (r) => {
    n = !0, o(r);
  }, { ...Ec(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Dc(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && B(e)) {
    const n = ve(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Ic(e, n);
    const r = (t.onCacheKey || Sc)(e), s = zn[r];
    if (s)
      return s;
    const { ast: a, detectError: l } = $c(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), i = Bo(a);
    return l ? i : zn[r] = i;
  } else {
    if (process.env.NODE_ENV !== "production" && !it(e))
      return pt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = zn[n];
      return o || (zn[n] = Bo(e));
    } else
      return Bo(e);
  }
}
let Tn = null;
function Mc(e) {
  Tn = e;
}
function Rc(e, t, n) {
  Tn && Tn.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Bc = /* @__PURE__ */ Fc("function:translate");
function Fc(e) {
  return (t) => Tn && Tn.emit(e, t);
}
const Se = {
  INVALID_ARGUMENT: zl,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Uc = 24;
function _t(e) {
  return pn(e, null, process.env.NODE_ENV !== "production" ? { messages: Vc } : void 0);
}
const Vc = {
  [Se.INVALID_ARGUMENT]: "Invalid arguments",
  [Se.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Se.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Se.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Se.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Se.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Se.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function vr(e, t) {
  return t.locale != null ? ms(t.locale) : ms(e.locale);
}
let Fo;
function ms(e) {
  if (B(e))
    return e;
  if (fe(e)) {
    if (e.resolvedOnce && Fo != null)
      return Fo;
    if (e.constructor.name === "Function") {
      const t = e();
      if (jl(t))
        throw _t(Se.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Fo = t;
    } else
      throw _t(Se.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw _t(Se.NOT_SUPPORT_LOCALE_TYPE);
}
function Hc(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...ye(t) ? t : Z(t) ? Object.keys(t) : B(t) ? [t] : [n]
  ])];
}
function Zo(e, t, n) {
  const o = B(n) ? n : Qn, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let s = r.__localeChainCache.get(o);
  if (!s) {
    s = [];
    let a = [n];
    for (; ye(a); )
      a = fs(s, a, t);
    const l = ye(t) || !ie(t) ? t : t.default ? t.default : null;
    a = B(l) ? [l] : l, ye(a) && fs(s, a, !1), r.__localeChainCache.set(o, s);
  }
  return s;
}
function fs(e, t, n) {
  let o = !0;
  for (let r = 0; r < t.length && ve(o); r++) {
    const s = t[r];
    B(s) && (o = jc(e, t[r], n));
  }
  return o;
}
function jc(e, t, n) {
  let o;
  const r = t.split("-");
  do {
    const s = r.join("-");
    o = Yc(e, s, n), r.splice(-1, 1);
  } while (r.length && o === !0);
  return o;
}
function Yc(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (ye(n) || ie(n)) && n[r] && (o = n[r]);
  }
  return o;
}
const Mt = [];
Mt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Mt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Mt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Mt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Mt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Wc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function qc(e) {
  return Wc.test(e);
}
function zc(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Kc(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Gc(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : qc(t) ? zc(t) : "*" + t;
}
function Xc(e) {
  const t = [];
  let n = -1, o = 0, r = 0, s, a, l, i, w, g, E;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = l : a += l;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), r++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, o = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, a === void 0 || (a = Gc(a), a === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const C = e[n + 1];
    if (o === 5 && C === "'" || o === 6 && C === '"')
      return n++, l = "\\" + C, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, s = e[n], !(s === "\\" && h())) {
      if (i = Kc(s), E = Mt[o], w = E[i] || E.l || 8, w === 8 || (o = w[0], w[1] !== void 0 && (g = d[w[1]], g && (l = s, g() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const ws = /* @__PURE__ */ new Map();
function Zc(e, t) {
  return Z(e) ? e[t] : null;
}
function Jc(e, t) {
  if (!Z(e))
    return null;
  let n = ws.get(t);
  if (n || (n = Xc(t), n && ws.set(t, n)), !n)
    return null;
  const o = n.length;
  let r = e, s = 0;
  for (; s < o; ) {
    const a = n[s];
    if (ma.includes(a) && it(r) || !Z(r) || !nt(r, a))
      return null;
    const l = r[a];
    if (l === void 0 || fe(r))
      return null;
    r = l, s++;
  }
  return r;
}
const Le = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, tn = 10, Qc = {
  [Le.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Le.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Le.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Le.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Le.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [Le.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [Le.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function Et(e, ...t) {
  return yo(Qc[e], ...t);
}
const eu = "11.4.4", Eo = -1, Qn = "en-US", un = "", ps = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function tu() {
  return {
    upper: (e, t) => t === "text" && B(e) ? e.toUpperCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && B(e) ? e.toLowerCase() : t === "vnode" && Z(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && B(e) ? ps(e) : t === "vnode" && Z(e) && "__v_isVNode" in e ? ps(e.children) : e
  };
}
let fa;
function nu(e) {
  fa = e;
}
let wa;
function ou(e) {
  wa = e;
}
let pa;
function ru(e) {
  pa = e;
}
let ha = null;
const su = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ha = e;
}, au = /* @__NO_SIDE_EFFECTS__ */ () => ha;
let ga = null;
const hs = (e) => {
  ga = e;
}, iu = () => ga;
let gs = 0;
function lu(e = {}) {
  const t = fe(e.onWarn) ? e.onWarn : pt, n = B(e.version) ? e.version : eu, o = B(e.locale) || fe(e.locale) ? e.locale : Qn, r = fe(o) ? Qn : o, s = ye(e.fallbackLocale) || ie(e.fallbackLocale) || B(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, a = ie(e.messages) ? e.messages : Uo(r), l = ie(e.datetimeFormats) ? e.datetimeFormats : Uo(r), i = ie(e.numberFormats) ? e.numberFormats : Uo(r), w = Ce(ce(), e.modifiers, tu()), g = e.pluralRules || ce(), E = fe(e.missing) ? e.missing : null, d = ve(e.missingWarn) || Jn(e.missingWarn) ? e.missingWarn : !0, h = ve(e.fallbackWarn) || Jn(e.fallbackWarn) ? e.fallbackWarn : !0, C = !!e.fallbackFormat, p = !!e.unresolving, T = fe(e.postTranslation) ? e.postTranslation : null, f = ie(e.processor) ? e.processor : null, b = ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, A = !!e.escapeParameter, m = fe(e.messageCompiler) ? e.messageCompiler : fa;
  process.env.NODE_ENV !== "production" && fe(e.messageCompiler) && Il(Et(Le.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const L = fe(e.messageResolver) ? e.messageResolver : wa || Zc, S = fe(e.localeFallbacker) ? e.localeFallbacker : pa || Hc, x = Z(e.fallbackContext) ? e.fallbackContext : void 0, K = e, Y = Z(K.__datetimeFormatters) ? K.__datetimeFormatters : /* @__PURE__ */ new Map(), H = Z(K.__numberFormatters) ? K.__numberFormatters : /* @__PURE__ */ new Map(), W = Z(K.__meta) ? K.__meta : {};
  gs++;
  const ne = {
    version: n,
    cid: gs,
    locale: o,
    fallbackLocale: s,
    messages: a,
    modifiers: w,
    pluralRules: g,
    missing: E,
    missingWarn: d,
    fallbackWarn: h,
    fallbackFormat: C,
    unresolving: p,
    postTranslation: T,
    processor: f,
    warnHtmlMessage: b,
    escapeParameter: A,
    messageCompiler: m,
    messageResolver: L,
    localeFallbacker: S,
    fallbackContext: x,
    onWarn: t,
    __meta: W
  };
  return ne.datetimeFormats = l, ne.numberFormats = i, ne.__datetimeFormatters = Y, ne.__numberFormatters = H, process.env.NODE_ENV !== "production" && (ne.__v_emitter = K.__v_emitter != null ? K.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Rc(ne, n, W), ne;
}
const Uo = (e) => ({ [e]: ce() });
function ko(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function ba(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function yr(e, t, n, o, r) {
  const { missing: s, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const l = e.__v_emitter;
    l && l.emit("missing", {
      locale: n,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (s !== null) {
    const l = s(e, n, t, r);
    return B(l) ? l : t;
  } else
    return process.env.NODE_ENV !== "production" && ba(o, t) && a(Et(Le.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function An(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function va(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function cu(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (va(e, t[o]))
      return !0;
  return !1;
}
const bs = typeof Intl < "u", ya = {
  dateTimeFormat: bs && typeof Intl.DateTimeFormat < "u",
  numberFormat: bs && typeof Intl.NumberFormat < "u"
};
function vs(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __datetimeFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !ya.dateTimeFormat)
    return s(Et(Le.CANNOT_FORMAT_DATE)), un;
  if (!B(t[0]) && !ta(t[0]) && !Te(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Le.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), un;
  const [i, w, g, E] = Jo(...t), d = ve(g.missingWarn) ? g.missingWarn : e.missingWarn, h = ve(g.fallbackWarn) ? g.fallbackWarn : e.fallbackWarn, C = !!g.part, p = vr(e, g), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    p
  );
  if (!B(i) || i === "")
    return new Intl.DateTimeFormat(p.replace(/!/g, ""), E).format(w);
  let f = {}, b, A = null, m = p, L = null;
  const S = "datetime format";
  for (let Y = 0; Y < T.length; Y++) {
    if (b = L = T[Y], process.env.NODE_ENV !== "production" && p !== b && ko(h, i) && s(Et(Le.FALLBACK_TO_DATE_FORMAT, {
      key: i,
      target: b
    })), process.env.NODE_ENV !== "production" && p !== b) {
      const H = e.__v_emitter;
      H && H.emit("fallback", {
        type: S,
        key: i,
        from: m,
        to: L,
        groupId: `${S}:${i}`
      });
    }
    if (f = n[b] || {}, A = f[i], ie(A))
      break;
    yr(e, i, b, d, S), m = L;
  }
  if (!ie(A) || !B(b))
    return o ? Eo : i;
  let x = `${b}__${i}`;
  _o(E) || (x = `${x}__${JSON.stringify(E)}`);
  let K = l.get(x);
  return K || (K = new Intl.DateTimeFormat(b, Ce({}, A, E)), l.set(x, K)), C ? K.formatToParts(w) : K.format(w);
}
const _a = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Jo(...e) {
  const [t, n, o, r] = e, s = ce();
  let a = ce(), l;
  if (B(t)) {
    const i = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!i)
      throw _t(Se.INVALID_ISO_DATE_ARGUMENT);
    const w = i[3] ? i[3].trim().startsWith("T") ? `${i[1].trim()}${i[3].trim()}` : `${i[1].trim()}T${i[3].trim()}` : i[1].trim();
    l = new Date(w);
    try {
      l.toISOString();
    } catch {
      throw _t(Se.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ta(t)) {
    if (isNaN(t.getTime()))
      throw _t(Se.INVALID_DATE_ARGUMENT);
    l = t;
  } else if (Te(t))
    l = t;
  else
    throw _t(Se.INVALID_ARGUMENT);
  return B(n) ? s.key = n : ie(n) && Object.keys(n).forEach((i) => {
    _a.includes(i) ? a[i] = n[i] : s[i] = n[i];
  }), B(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", l, s, a];
}
function ys(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__datetimeFormatters.has(s) && o.__datetimeFormatters.delete(s);
  }
}
function _s(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __numberFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !ya.numberFormat)
    return s(Et(Le.CANNOT_FORMAT_NUMBER)), un;
  if (!Te(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Le.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), un;
  const [i, w, g, E] = Qo(...t), d = ve(g.missingWarn) ? g.missingWarn : e.missingWarn, h = ve(g.fallbackWarn) ? g.fallbackWarn : e.fallbackWarn, C = !!g.part, p = vr(e, g), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    p
  );
  if (!B(i) || i === "")
    return new Intl.NumberFormat(p.replace(/!/g, ""), E).format(w);
  let f = {}, b, A = null, m = p, L = null;
  const S = "number format";
  for (let Y = 0; Y < T.length; Y++) {
    if (b = L = T[Y], process.env.NODE_ENV !== "production" && p !== b && ko(h, i) && s(Et(Le.FALLBACK_TO_NUMBER_FORMAT, {
      key: i,
      target: b
    })), process.env.NODE_ENV !== "production" && p !== b) {
      const H = e.__v_emitter;
      H && H.emit("fallback", {
        type: S,
        key: i,
        from: m,
        to: L,
        groupId: `${S}:${i}`
      });
    }
    if (f = n[b] || {}, A = f[i], ie(A))
      break;
    yr(e, i, b, d, S), m = L;
  }
  if (!ie(A) || !B(b))
    return o ? Eo : i;
  let x = `${b}__${i}`;
  _o(E) || (x = `${x}__${JSON.stringify(E)}`);
  let K = l.get(x);
  return K || (K = new Intl.NumberFormat(b, Ce({}, A, E)), l.set(x, K)), C ? K.formatToParts(w) : K.format(w);
}
const Ea = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Qo(...e) {
  const [t, n, o, r] = e, s = ce();
  let a = ce();
  if (!Te(t))
    throw _t(Se.INVALID_ARGUMENT);
  const l = t;
  return B(n) ? s.key = n : ie(n) && Object.keys(n).forEach((i) => {
    Ea.includes(i) ? a[i] = n[i] : s[i] = n[i];
  }), B(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", l, s, a];
}
function Es(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__numberFormatters.has(s) && o.__numberFormatters.delete(s);
  }
}
const uu = (e) => e, du = (e) => "", mu = "text", fu = (e) => e.length === 0 ? "" : hr(e), wu = Yl;
function Vo(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function pu(e) {
  var n, o;
  const t = Te(e.pluralIndex) ? e.pluralIndex : -1;
  return Te((n = e.named) == null ? void 0 : n.count) ? e.named.count : Te((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function hu(e = {}) {
  var f, b, A, m;
  const t = e.locale, n = pu(e), o = B(t) && fe((f = e.pluralRules) == null ? void 0 : f[t]) ? e.pluralRules[t] : Vo, r = o === Vo ? void 0 : Vo, s = (L) => L[o(n, L.length, r)], a = e.list || [], l = (L) => a[L], i = e.named || ce();
  Te(e.pluralIndex) && (i.count || (i.count = e.pluralIndex), i.n || (i.n = e.pluralIndex));
  const w = (L) => i[L];
  function g(L, S) {
    const x = fe(e.messages) ? e.messages(L, !!S) : Z(e.messages) ? e.messages[L] : !1;
    return x || (e.parent ? e.parent.message(L) : du);
  }
  const E = (L) => e.modifiers ? e.modifiers[L] : uu, d = fe((b = e.processor) == null ? void 0 : b.normalize) ? e.processor.normalize : fu, h = fe((A = e.processor) == null ? void 0 : A.interpolate) ? e.processor.interpolate : wu, C = B((m = e.processor) == null ? void 0 : m.type) ? e.processor.type : mu, T = {
    list: l,
    named: w,
    plural: s,
    linked: (L, ...S) => {
      const [x, K] = S;
      let Y = "text", H = "";
      S.length === 1 ? Z(x) ? (H = x.modifier || H, Y = x.type || Y) : B(x) && (H = x || H) : S.length === 2 && (B(x) && (H = x || H), B(K) && (Y = K || Y));
      const W = g(L, !0)(T), ne = W === "" || W === void 0 ? L : W, Je = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        Y === "vnode" && ye(ne) && H ? ne[0] : ne
      );
      return H ? E(H)(Je, Y) : Je;
    },
    message: g,
    type: C,
    interpolate: h,
    normalize: d,
    values: Ce(ce(), a, i)
  };
  return T;
}
const ks = () => "", tt = (e) => fe(e);
function xs(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: r, messageCompiler: s, fallbackLocale: a, messages: l } = e, [i, w] = er(...t), g = ve(w.missingWarn) ? w.missingWarn : e.missingWarn, E = ve(w.fallbackWarn) ? w.fallbackWarn : e.fallbackWarn, d = ve(w.escapeParameter) ? w.escapeParameter : e.escapeParameter, h = !!w.resolvedMessage, C = B(w.default) || ve(w.default) ? ve(w.default) ? s ? i : () => i : w.default : n ? s ? i : () => i : null, p = n || C != null && (B(C) || fe(C)), T = vr(e, w);
  d && gu(w);
  let [f, b, A] = h ? [
    i,
    T,
    l[T] || ce()
  ] : ka(e, i, T, a, E, g), m = f, L = i;
  if (!h && !(B(m) || it(m) || tt(m)) && p && (m = C, L = m), !h && (!(B(m) || it(m) || tt(m)) || !B(b)))
    return r ? Eo : i;
  if (process.env.NODE_ENV !== "production" && B(m) && e.messageCompiler == null)
    return pt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${i}'.`), i;
  let S = !1;
  const x = () => {
    S = !0;
  }, K = tt(m) ? m : xa(e, i, b, m, L, x);
  if (S)
    return m;
  const Y = _u(e, b, A, w), H = hu(Y), W = bu(e, K, H);
  let ne = o ? o(W, i) : W;
  if (d && B(ne) && (ne = Vl(ne)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Je = {
      timestamp: Date.now(),
      key: B(i) ? i : tt(m) ? m.key : "",
      locale: b || (tt(m) ? m.locale : ""),
      format: B(m) ? m : tt(m) ? m.source : "",
      message: ne
    };
    Je.meta = Ce({}, e.__meta, /* @__PURE__ */ au() || {}), Bc(Je);
  }
  return ne;
}
function gu(e) {
  ye(e.list) ? e.list = e.list.map((t) => B(t) ? ss(t) : t) : Z(e.named) && Object.keys(e.named).forEach((t) => {
    B(e.named[t]) && (e.named[t] = ss(e.named[t]));
  });
}
function ka(e, t, n, o, r, s) {
  const { messages: a, onWarn: l, messageResolver: i, localeFallbacker: w } = e, g = w(e, o, n);
  let E = ce(), d, h = null, C = n, p = null;
  const T = "translate";
  for (let f = 0; f < g.length; f++) {
    d = p = g[f], process.env.NODE_ENV !== "production" && n !== d && !va(n, d) && ko(r, t) && l(Et(Le.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    }));
    const b = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== d && b && b.emit("fallback", {
      type: T,
      key: t,
      from: C,
      to: p,
      groupId: `${T}:${t}`
    }), E = a[d] || ce();
    let A = null, m, L;
    if (process.env.NODE_ENV !== "production" && Ct && b && (A = window.performance.now(), m = "intlify-message-resolve-start", L = "intlify-message-resolve-end", We && We(m)), (h = i(E, t)) === null && (h = E[t]), process.env.NODE_ENV !== "production" && Ct && b) {
      const S = window.performance.now();
      b && A && h && b.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: h,
        time: S - A,
        groupId: `${T}:${t}`
      }), m && L && We && Kt && (We(L), Kt("intlify message resolve", m, L));
    }
    if (B(h) || it(h) || tt(h))
      break;
    if (!cu(d, g)) {
      const S = yr(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        s,
        T
      );
      S !== t && (h = S);
    }
    C = p;
  }
  return [h, d, E];
}
function xa(e, t, n, o, r, s) {
  const { messageCompiler: a, warnHtmlMessage: l } = e;
  if (tt(o)) {
    const h = o;
    return h.locale = h.locale || n, h.key = h.key || t, h;
  }
  if (a == null) {
    const h = () => o;
    return h.locale = n, h.key = t, h;
  }
  const i = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let w = null, g, E;
  process.env.NODE_ENV !== "production" && Ct && i && (w = window.performance.now(), g = "intlify-message-compilation-start", E = "intlify-message-compilation-end", We && We(g));
  const d = a(o, vu(e, n, r, o, l, s));
  if (process.env.NODE_ENV !== "production" && Ct && i) {
    const h = window.performance.now();
    i && w && i.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: h - w,
      groupId: `translate:${t}`
    }), g && E && We && Kt && (We(E), Kt("intlify message compilation", g, E));
  }
  return d.locale = n, d.key = t, d.source = o, d;
}
function bu(e, t, n) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let r = null, s, a;
  process.env.NODE_ENV !== "production" && Ct && o && (r = window.performance.now(), s = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", We && We(s));
  const l = t(n);
  if (process.env.NODE_ENV !== "production" && Ct && o) {
    const i = window.performance.now();
    o && r && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: l,
      time: i - r,
      groupId: `translate:${t.key}`
    }), s && a && We && Kt && (We(a), Kt("intlify message evaluation", s, a));
  }
  return l;
}
function er(...e) {
  const [t, n, o] = e, r = ce();
  if (!B(t) && !Te(t) && !tt(t) && !it(t))
    throw _t(Se.INVALID_ARGUMENT);
  const s = Te(t) ? String(t) : (tt(t), t);
  return Te(n) ? r.plural = n : B(n) ? r.default = n : ie(n) && !_o(n) ? r.named = n : ye(n) && (r.list = n), Te(o) ? r.plural = o : B(o) ? r.default = o : ie(o) && Ce(r, o), [s, r];
}
function vu(e, t, n, o, r, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: r,
    onError: (a) => {
      if (s && s(a), process.env.NODE_ENV !== "production") {
        const l = yu(o), i = a.location && l && Wl(l, a.location.start.offset, a.location.end.offset), w = e.__v_emitter;
        w && l && w.emit("compile-error", {
          message: l,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const g = `Message compilation error: ${a.message}`;
        throw new SyntaxError(i ? `${g}
${i}` : g);
      }
      throw a;
    },
    onCacheKey: (a) => $l(t, n, a)
  };
}
function yu(e) {
  if (B(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function _u(e, t, n, o) {
  const { modifiers: r, pluralRules: s, messageResolver: a, fallbackLocale: l, fallbackWarn: i, missingWarn: w, fallbackContext: g } = e, d = {
    locale: t,
    modifiers: r,
    pluralRules: s,
    messages: (h, C) => {
      let p = a(n, h);
      if (p == null && (g || C)) {
        const [T, , f] = ka(
          g || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          h,
          t,
          l,
          i,
          w
        );
        p = T ?? a(f, h);
      }
      if (B(p) || it(p)) {
        let T = !1;
        const b = xa(e, h, t, p, h, () => {
          T = !0;
        });
        return T ? ks : b;
      } else return tt(p) ? p : ks;
    }
  };
  return e.processor && (d.processor = e.processor), o.list && (d.list = o.list), o.named && (d.named = o.named), Te(o.plural) && (d.pluralIndex = o.plural), d;
}
kc();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const Eu = "11.4.4";
function ku() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Yt().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Yt().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Yt().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Yt().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Ae = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Uc,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function sn(e, ...t) {
  return pn(e, null, process.env.NODE_ENV !== "production" ? { messages: xu, args: t } : void 0);
}
const xu = {
  [Ae.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Ae.INVALID_ARGUMENT]: "Invalid argument",
  [Ae.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Ae.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Ae.UNEXPECTED_ERROR]: "Unexpected error",
  [Ae.REQUIRED_VALUE]: "Required in value: {0}",
  [Ae.INVALID_VALUE]: "Invalid value",
  [Ae.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Ae.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Ae.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, tr = /* @__PURE__ */ At("__translateVNode"), nr = /* @__PURE__ */ At("__datetimeParts"), or = /* @__PURE__ */ At("__numberParts"), Nn = /* @__PURE__ */ At("__enableEmitter"), On = /* @__PURE__ */ At("__disableEmitter"), Cu = At("__setPluralRules"), Ca = /* @__PURE__ */ At("__injectWithOption"), rn = /* @__PURE__ */ At("__dispose"), wt = {
  FALLBACK_TO_ROOT: tn,
  // 10
  NOT_FOUND_PARENT_SCOPE: tn + 1,
  IGNORE_OBJ_FLATTEN: tn + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: tn + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: tn + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: tn + 5
}, Au = {
  [wt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [wt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [wt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [wt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function eo(e, ...t) {
  return yo(Au[e], ...t);
}
function Pn(e) {
  if (!Z(e) || it(e))
    return e;
  for (const t in e)
    if (nt(e, t))
      if (!t.includes("."))
        Z(e[t]) && Pn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let r = e, s = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in r || (r[n[a]] = ce()), !Z(r[n[a]])) {
            process.env.NODE_ENV !== "production" && pt(eo(wt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), s = !0;
            break;
          }
          r = r[n[a]];
        }
        if (s || (it(r) ? ma.includes(n[o]) || delete e[t] : (r[n[o]] = e[t], delete e[t])), !it(r)) {
          const a = r[n[o]];
          Z(a) && Pn(a);
        }
      }
  return e;
}
function Aa(e, t) {
  const { messages: n, __i18n: o, messageResolver: r, flatJson: s } = t, a = ie(n) ? n : ye(o) ? ce() : { [e]: ce() };
  if (ye(o) && o.forEach((l) => {
    if ("locale" in l && "resource" in l) {
      const { locale: i, resource: w } = l;
      i ? (a[i] = a[i] || ce(), Xn(w, a[i])) : Xn(w, a);
    } else
      B(l) && Xn(JSON.parse(l), a);
  }), r == null && s)
    for (const l in a)
      nt(a, l) && Pn(a[l]);
  return a;
}
function La(e) {
  return e.type;
}
function Lu(e, t, n) {
  let o = Z(t.messages) ? t.messages : ce();
  "__i18nGlobal" in n && (o = Aa(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(o);
  r.length && r.forEach((s) => {
    e.mergeLocaleMessage(s, o[s]);
  });
  {
    if (Z(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (Z(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function Cs(e) {
  return Ko(Ll, null, e, 0);
}
function _r() {
  const e = "currentInstance";
  return e in Do ? Do[e] : Do.getCurrentInstance();
}
const As = "__INTLIFY_META__", Ls = () => [], Tu = () => !1;
let Ts = 0;
function Ns(e) {
  return (t, n, o, r) => e(n, o, _r() || void 0, r);
}
const Nu = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = _r();
  let t = null;
  return e && (t = La(e)[As]) ? { [As]: t } : null;
};
function Os(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, r = e.flatJson, s = Ct ? Ve : Al;
  let a = ve(e.inheritLocale) ? e.inheritLocale : !0;
  const l = s(
    // prettier-ignore
    t && a ? t.locale.value : B(e.locale) ? e.locale : Qn
  ), i = s(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : B(e.fallbackLocale) || ye(e.fallbackLocale) || ie(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : l.value
  ), w = s(Aa(l.value, e)), g = s(ie(e.datetimeFormats) ? e.datetimeFormats : { [l.value]: {} }), E = s(ie(e.numberFormats) ? e.numberFormats : { [l.value]: {} });
  let d = t ? t.missingWarn : ve(e.missingWarn) || Jn(e.missingWarn) ? e.missingWarn : !0, h = t ? t.fallbackWarn : ve(e.fallbackWarn) || Jn(e.fallbackWarn) ? e.fallbackWarn : !0, C = t ? t.fallbackRoot : ve(e.fallbackRoot) ? e.fallbackRoot : !0, p = !!e.fallbackFormat, T = fe(e.missing) ? e.missing : null, f = fe(e.missing) ? Ns(e.missing) : null, b = fe(e.postTranslation) ? e.postTranslation : null, A = t ? t.warnHtmlMessage : ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, m = !!e.escapeParameter;
  const L = t ? t.modifiers : ie(e.modifiers) ? e.modifiers : {};
  let S = e.pluralRules || t && t.pluralRules, x;
  x = (() => {
    o && hs(null);
    const k = {
      version: Eu,
      locale: l.value,
      fallbackLocale: i.value,
      messages: w.value,
      modifiers: L,
      pluralRules: S,
      missing: f === null ? void 0 : f,
      missingWarn: d,
      fallbackWarn: h,
      fallbackFormat: p,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: A,
      escapeParameter: m,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    k.datetimeFormats = g.value, k.numberFormats = E.value, k.__datetimeFormatters = ie(x) ? x.__datetimeFormatters : void 0, k.__numberFormatters = ie(x) ? x.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (k.__v_emitter = ie(x) ? x.__v_emitter : void 0);
    const O = lu(k);
    return o && hs(O), O;
  })(), An(x, l.value, i.value);
  function Y() {
    return [
      l.value,
      i.value,
      w.value,
      g.value,
      E.value
    ];
  }
  const H = Ye({
    get: () => l.value,
    set: (k) => {
      x.locale = k, l.value = k;
    }
  }), W = Ye({
    get: () => i.value,
    set: (k) => {
      x.fallbackLocale = k, i.value = k, An(x, l.value, k);
    }
  }), ne = Ye(() => w.value), Je = /* @__PURE__ */ Ye(() => g.value), q = /* @__PURE__ */ Ye(() => E.value);
  function M() {
    return fe(b) ? b : null;
  }
  function $(k) {
    b = k, x.postTranslation = k;
  }
  function V() {
    return T;
  }
  function D(k) {
    k !== null && (f = Ns(k)), T = k, x.missing = f;
  }
  function G(k, O) {
    return k !== "translate" || !O.resolvedMessage;
  }
  const j = (k, O, ee, pe, Ft, Ut) => {
    Y();
    let et;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = t ? iu() : void 0), et = k(x);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = void 0);
    }
    if (ee !== "translate exists" && // for not `te` (e.g `t`)
    Te(et) && et === Eo || ee === "translate exists" && !et) {
      const [Vt, _l] = O();
      if (process.env.NODE_ENV !== "production" && t && B(Vt) && G(ee, _l) && (C && (ko(h, Vt) || ba(d, Vt)) && pt(eo(wt.FALLBACK_TO_ROOT, {
        key: Vt,
        type: ee
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ns } = x;
        ns && C && ns.emit("fallback", {
          type: ee,
          key: Vt,
          to: "global",
          groupId: `${ee}:${Vt}`
        });
      }
      return t && C ? pe(t) : Ft(Vt);
    } else {
      if (Ut(et))
        return et;
      throw sn(Ae.UNEXPECTED_RETURN_TYPE);
    }
  };
  function J(...k) {
    return j((O) => Reflect.apply(xs, null, [O, ...k]), () => er(...k), "translate", (O) => Reflect.apply(O.t, O, [...k]), (O) => O, (O) => B(O));
  }
  function de(...k) {
    const [O, ee, pe] = k;
    if (pe && !Z(pe))
      throw sn(Ae.INVALID_ARGUMENT);
    return J(O, ee, Ce({ resolvedMessage: !0 }, pe || {}));
  }
  function we(...k) {
    return j((O) => Reflect.apply(vs, null, [O, ...k]), () => Jo(...k), "datetime format", (O) => Reflect.apply(O.d, O, [...k]), () => un, (O) => B(O) || ye(O));
  }
  function ke(...k) {
    return j((O) => Reflect.apply(_s, null, [O, ...k]), () => Qo(...k), "number format", (O) => Reflect.apply(O.n, O, [...k]), () => un, (O) => B(O) || ye(O));
  }
  function Pe(k) {
    return k.map((O) => B(O) || Te(O) || ve(O) ? Cs(String(O)) : O);
  }
  const st = {
    normalize: Pe,
    interpolate: (k) => k,
    type: "vnode"
  };
  function lt(...k) {
    return j((O) => {
      let ee;
      const pe = O;
      try {
        pe.processor = st, ee = Reflect.apply(xs, null, [pe, ...k]);
      } finally {
        pe.processor = null;
      }
      return ee;
    }, () => er(...k), "translate", (O) => O[tr](...k), (O) => [Cs(O)], (O) => ye(O));
  }
  function at(...k) {
    return j((O) => Reflect.apply(_s, null, [O, ...k]), () => Qo(...k), "number format", (O) => O[or](...k), Ls, (O) => B(O) || ye(O));
  }
  function xe(...k) {
    return j((O) => Reflect.apply(vs, null, [O, ...k]), () => Jo(...k), "datetime format", (O) => O[nr](...k), Ls, (O) => B(O) || ye(O));
  }
  function Qe(k) {
    S = k, x.pluralRules = S;
  }
  function vt(k, O) {
    return j(() => {
      if (!k)
        return !1;
      const ee = B(O) ? O : l.value, pe = B(O) ? [ee] : Zo(x, i.value, ee);
      for (let Ft = 0; Ft < pe.length; Ft++) {
        const Ut = Bt(pe[Ft]);
        let et = x.messageResolver(Ut, k);
        if (et === null && (et = Ut[k]), it(et) || tt(et) || B(et))
          return !0;
      }
      return !1;
    }, () => [k], "translate exists", (ee) => Reflect.apply(ee.te, ee, [k, O]), Tu, (ee) => ve(ee));
  }
  function ct(k) {
    let O = null;
    const ee = Zo(x, i.value, l.value);
    for (let pe = 0; pe < ee.length; pe++) {
      const Ft = w.value[ee[pe]] || {}, Ut = x.messageResolver(Ft, k);
      if (Ut != null) {
        O = Ut;
        break;
      }
    }
    return O;
  }
  function xn(k) {
    const O = ct(k);
    return O ?? (t ? t.tm(k) || {} : {});
  }
  function Bt(k) {
    return w.value[k] || {};
  }
  function Cn(k, O) {
    if (r) {
      const ee = { [k]: O };
      for (const pe in ee)
        nt(ee, pe) && Pn(ee[pe]);
      O = ee[k];
    }
    w.value[k] = O, x.messages = w.value;
  }
  function $o(k, O) {
    w.value[k] = w.value[k] || {};
    const ee = { [k]: O };
    if (r)
      for (const pe in ee)
        nt(ee, pe) && Pn(ee[pe]);
    O = ee[k], Xn(O, w.value[k]), x.messages = w.value;
  }
  function c(k) {
    return g.value[k] || {};
  }
  function u(k, O) {
    g.value[k] = O, x.datetimeFormats = g.value, ys(x, k, O);
  }
  function N(k, O) {
    g.value[k] = Ce(g.value[k] || {}, O), x.datetimeFormats = g.value, ys(x, k, O);
  }
  function R(k) {
    return E.value[k] || {};
  }
  function me(k, O) {
    E.value[k] = O, x.numberFormats = E.value, Es(x, k, O);
  }
  function he(k, O) {
    E.value[k] = Ce(E.value[k] || {}, O), x.numberFormats = E.value, Es(x, k, O);
  }
  Ts++, t && Ct && (zo(t.locale, (k) => {
    a && (l.value = k, x.locale = k, An(x, l.value, i.value));
  }), zo(t.fallbackLocale, (k) => {
    a && (i.value = k, x.fallbackLocale = k, An(x, l.value, i.value));
  }));
  const Q = {
    id: Ts,
    locale: H,
    fallbackLocale: W,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(k) {
      a = k, k && t && (l.value = t.locale.value, i.value = t.fallbackLocale.value, An(x, l.value, i.value));
    },
    get availableLocales() {
      return Object.keys(w.value).sort();
    },
    messages: ne,
    get modifiers() {
      return L;
    },
    get pluralRules() {
      return S || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return d;
    },
    set missingWarn(k) {
      d = k, x.missingWarn = d;
    },
    get fallbackWarn() {
      return h;
    },
    set fallbackWarn(k) {
      h = k, x.fallbackWarn = h;
    },
    get fallbackRoot() {
      return C;
    },
    set fallbackRoot(k) {
      C = k;
    },
    get fallbackFormat() {
      return p;
    },
    set fallbackFormat(k) {
      p = k, x.fallbackFormat = p;
    },
    get warnHtmlMessage() {
      return A;
    },
    set warnHtmlMessage(k) {
      A = k, x.warnHtmlMessage = k;
    },
    get escapeParameter() {
      return m;
    },
    set escapeParameter(k) {
      m = k, x.escapeParameter = k;
    },
    t: J,
    getLocaleMessage: Bt,
    setLocaleMessage: Cn,
    mergeLocaleMessage: $o,
    getPostTranslationHandler: M,
    setPostTranslationHandler: $,
    getMissingHandler: V,
    setMissingHandler: D,
    [Cu]: Qe
  };
  return Q.datetimeFormats = Je, Q.numberFormats = q, Q.rt = de, Q.te = vt, Q.tm = xn, Q.d = we, Q.n = ke, Q.getDateTimeFormat = c, Q.setDateTimeFormat = u, Q.mergeDateTimeFormat = N, Q.getNumberFormat = R, Q.setNumberFormat = me, Q.mergeNumberFormat = he, Q[Ca] = n, Q[tr] = lt, Q[nr] = xe, Q[or] = at, process.env.NODE_ENV !== "production" && (Q[Nn] = (k) => {
    x.__v_emitter = k;
  }, Q[On] = () => {
    x.__v_emitter = void 0;
  }), Q;
}
function to(e, t) {
}
const Er = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Ou({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, r) => [
    ...o,
    // prettier-ignore
    ...r.type === In ? r.children : [r]
  ], []) : t.reduce((n, o) => {
    const r = e[o];
    return r && (n[o] = r()), n;
  }, ce());
}
function Ta() {
  return In;
}
Ce({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Te(e) || !isNaN(e)
  }
}, Er);
function Pu(e) {
  return ye(e) && !B(e[0]);
}
function Na(e, t, n, o) {
  const { slots: r, attrs: s } = t;
  return () => {
    const a = () => {
      const w = { part: !0 };
      let g = ce();
      e.locale && (w.locale = e.locale), B(e.format) ? w.key = e.format : Z(e.format) && (B(e.format.key) && (w.key = e.format.key), g = Object.keys(e.format).reduce((h, C) => n.includes(C) ? Ce(ce(), h, { [C]: e.format[C] }) : h, ce()));
      const E = o(e.value, w, g);
      let d = [w.key];
      return ye(E) ? d = E.map((h, C) => {
        const p = r[h.type], T = p ? p({ [h.type]: h.value, index: C, parts: E }) : [h.value];
        return Pu(T) && (T[0].key = `${h.type}-${C}`), T;
      }) : B(E) && (d = [E]), d;
    }, l = Ce(ce(), s), i = B(e.tag) || Z(e.tag) ? e.tag : Ta();
    return Z(i) ? Zn(i, l, { default: a }) : Zn(i, l, a());
  };
}
Ce({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Er);
const Iu = /* @__PURE__ */ At("global-vue-i18n");
function Rt(e = {}) {
  const t = _r();
  if (t == null)
    throw sn(Ae.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw sn(Ae.NOT_INSTALLED);
  const n = Su(t), o = Du(n), r = La(t), s = $u(e, r);
  if (s === "global")
    return Lu(o, e, r), o;
  if (s === "parent") {
    let i = Ps(n, t, e.__useComponent);
    return i == null && (process.env.NODE_ENV !== "production" && pt(eo(wt.NOT_FOUND_PARENT_SCOPE)), i = o), i;
  }
  if (s === "isolated") {
    if (n.mode !== "composition")
      throw sn(Ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const i = n, w = Ce({}, e), g = Ps(n, t);
    w.__root = g || o;
    const E = Os(w);
    i.__composerExtend && (E[rn] = i.__composerExtend(E));
    let d = null;
    if (process.env.NODE_ENV !== "production") {
      d = oa();
      const C = E;
      C[Nn] && C[Nn](d), d.on("*", to);
    }
    return El() && kl(() => {
      if (process.env.NODE_ENV !== "production") {
        d && d.off("*", to);
        const p = E;
        p[On] && p[On]();
      }
      const C = E[rn];
      C && (C(), delete E[rn]);
    }), E;
  }
  const a = n;
  let l = a.__getInstance(t);
  if (l == null) {
    const i = Ce({}, e);
    "__i18n" in r && (i.__i18n = r.__i18n), o && (i.__root = o), l = Os(i), a.__composerExtend && (l[rn] = a.__composerExtend(l)), Ru(a, t, l), a.__setInstance(t, l);
  } else
    process.env.NODE_ENV !== "production" && s === "local" && pt(eo(wt.DUPLICATE_USE_I18N_CALLING));
  return l;
}
function Su(e) {
  const t = xl(e.isCE ? Iu : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw sn(e.isCE ? Ae.NOT_INSTALLED_WITH_PROVIDE : Ae.UNEXPECTED_ERROR);
  return t;
}
function $u(e, t) {
  return _o(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Du(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Ps(e, t, n = !1) {
  let o = null;
  const r = t.root;
  let s = Mu(t, n);
  for (; s != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const l = a.__getInstance(s);
      l != null && (o = l.__composer, n && o && !o[Ca] && (o = null));
    }
    if (o != null || r === s)
      break;
    s = s.parent;
  }
  return o;
}
function Mu(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Ru(e, t, n) {
  let o = null;
  mr(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = oa();
      const r = n;
      r[Nn] && r[Nn](o), o.on("*", to);
    }
  }, t), Cl(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", to), r[On] && r[On](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const s = r[rn];
    s && (s(), delete r[rn]);
  }, t);
}
Ce({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Er);
ku();
nu(Dc);
ou(Jc);
ru(Zo);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Yt();
  e.__INTLIFY__ = !0, Mc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Bu(e) {
  const t = Ve([]), n = Ve(!1), o = Ve(null), r = async () => {
    n.value = !0, o.value = null;
    try {
      t.value = await e.getWeeklyReport();
    } catch (l) {
      o.value = l.message || "無法載入營收報表";
    } finally {
      n.value = !1;
    }
  }, s = Ye(() => t.value.reduce((l, i) => l + parseFloat(i.total_amount), 0)), a = Ye(() => t.value.reduce((l, i) => l + i.order_count, 0));
  return {
    reports: t,
    isLoading: n,
    reportError: o,
    fetchWeeklyData: r,
    weeklyTotalRevenue: s,
    weeklyTotalOrders: a
  };
}
const Fu = { class: "p-6 max-w-4xl mx-auto bg-gray-50" }, Uu = { class: "mb-8" }, Vu = { class: "text-3xl font-black text-gray-900" }, Hu = { class: "text-gray-700" }, ju = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" }, Yu = { class: "bg-blue-700 p-6 rounded-3xl text-white shadow-xl" }, Wu = { class: "text-blue-100 font-medium" }, qu = { class: "text-4xl font-black mt-2" }, zu = { class: "bg-white p-6 rounded-3xl border border-gray-100 shadow-sm" }, Ku = { class: "text-gray-700 font-medium" }, Gu = { class: "text-4xl font-black mt-2 text-gray-700" }, Xu = { class: "text-lg" }, Zu = {
  key: 0,
  class: "text-center py-20"
}, Ju = { class: "mt-4 text-blue-700 font-bold" }, Qu = {
  key: 1,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl border border-red-100"
}, ed = {
  key: 2,
  class: "bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden"
}, td = { class: "w-full text-left" }, nd = { class: "bg-gray-50 border-b border-gray-100" }, od = { class: "px-6 py-4 text-gray-700 font-bold" }, rd = { class: "px-6 py-4 text-gray-700 font-bold" }, sd = { class: "px-6 py-4 text-gray-700 font-bold text-right" }, ad = { class: "divide-y divide-gray-50" }, id = { class: "px-6 py-4 font-medium text-gray-700" }, ld = { class: "px-6 py-4 text-gray-700" }, cd = { class: "px-6 py-4 text-right font-bold text-blue-700" }, Kb = /* @__PURE__ */ $t({
  __name: "RevenueReportPage",
  props: {
    revenueApi: {}
  },
  setup(e) {
    const { t, locale: n } = Rt(), o = e, {
      reports: r,
      isLoading: s,
      reportError: a,
      fetchWeeklyData: l,
      weeklyTotalRevenue: i,
      weeklyTotalOrders: w
    } = Bu(o.revenueApi);
    return mr(() => {
      l();
    }), (g, E) => (X(), te("div", Fu, [
      _("header", Uu, [
        _("h1", Vu, I(P(t)("report.title")), 1),
        _("p", Hu, I(P(t)("report.subtitle")), 1)
      ]),
      _("div", ju, [
        _("div", Yu, [
          _("p", Wu, I(P(t)("report.weeklyRevenue")), 1),
          _("h2", qu, "$ " + I(P(i).toLocaleString()), 1)
        ]),
        _("div", zu, [
          _("p", Ku, I(P(t)("report.weeklyOrders")), 1),
          _("h2", Gu, [
            Lt(I(P(w)) + " ", 1),
            _("span", Xu, I(P(t)("report.orderUnit")), 1)
          ])
        ])
      ]),
      P(s) ? (X(), te("div", Zu, [
        E[0] || (E[0] = _("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        _("p", Ju, I(P(t)("common.calculating")), 1)
      ])) : P(a) ? (X(), te("div", Qu, I(P(a)), 1)) : (X(), te("div", ed, [
        _("table", td, [
          _("thead", nd, [
            _("tr", null, [
              _("th", od, I(P(t)("report.dateCol")), 1),
              _("th", rd, I(P(t)("report.ordersCol")), 1),
              _("th", sd, I(P(t)("report.revenueCol")), 1)
            ])
          ]),
          _("tbody", ad, [
            (X(!0), te(In, null, fr(P(r), (d) => (X(), te("tr", {
              key: d.report_date,
              class: "hover:bg-gray-50 transition"
            }, [
              _("td", id, I(new Date(d.report_date).toLocaleDateString(P(n))), 1),
              _("td", ld, I(d.order_count) + " " + I(P(t)("report.orderUnit")), 1),
              _("td", cd, " $ " + I(parseFloat(d.total_amount).toLocaleString()), 1)
            ]))), 128))
          ])
        ])
      ]))
    ]));
  }
});
function ud(e) {
  const t = Ve(null), n = Ve(null), o = Ve(!1), r = Ve(null);
  return {
    paymentInfo: t,
    isLoading: o,
    paymentError: r,
    fetchPaymentInfo: async () => {
      o.value = !0, r.value = null;
      try {
        t.value = await e.getMerchantPaymentInfo();
      } catch (g) {
        r.value = g.message || "無法載入金流資訊";
      } finally {
        o.value = !1;
      }
    },
    fetchPaymentInfoPaginated: async (g) => {
      o.value = !0, r.value = null;
      try {
        const E = await e.getMerchantPaymentInfoPaginated(g);
        let d = {
          data: [],
          total: 0,
          page: (g == null ? void 0 : g.page) || 1,
          limit: (g == null ? void 0 : g.limit) || 10
        };
        if (Array.isArray(E))
          d = {
            data: E,
            total: Number(E.total ?? E.length),
            page: (g == null ? void 0 : g.page) || 1,
            limit: (g == null ? void 0 : g.limit) || 10
          };
        else if (E && typeof E == "object" && "data" in E) {
          const h = E;
          d = {
            data: Array.isArray(h.data) ? h.data : [],
            total: Number(h.total ?? 0),
            page: Number(h.page || (g == null ? void 0 : g.page) || 1),
            limit: Number(h.limit || (g == null ? void 0 : g.limit) || 10)
          };
        }
        return t.value = d.data, n.value = d, d;
      } catch (E) {
        throw r.value = E.message || "無法載入金流資訊", E;
      } finally {
        o.value = !1;
      }
    },
    createInvoice: async (g) => await e.createInvoice(g),
    queryCompanyName: async (g) => await e.queryCompanyName(g),
    voidPayment: async (g) => await e.voidPayment(g)
  };
}
var kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Oa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = 1e3, o = 6e4, r = 36e5, s = "millisecond", a = "second", l = "minute", i = "hour", w = "day", g = "week", E = "month", d = "quarter", h = "year", C = "date", p = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, f = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(q) {
      var M = ["th", "st", "nd", "rd"], $ = q % 100;
      return "[" + q + (M[($ - 20) % 10] || M[$] || M[0]) + "]";
    } }, A = function(q, M, $) {
      var V = String(q);
      return !V || V.length >= M ? q : "" + Array(M + 1 - V.length).join($) + q;
    }, m = { s: A, z: function(q) {
      var M = -q.utcOffset(), $ = Math.abs(M), V = Math.floor($ / 60), D = $ % 60;
      return (M <= 0 ? "+" : "-") + A(V, 2, "0") + ":" + A(D, 2, "0");
    }, m: function q(M, $) {
      if (M.date() < $.date()) return -q($, M);
      var V = 12 * ($.year() - M.year()) + ($.month() - M.month()), D = M.clone().add(V, E), G = $ - D < 0, j = M.clone().add(V + (G ? -1 : 1), E);
      return +(-(V + ($ - D) / (G ? D - j : j - D)) || 0);
    }, a: function(q) {
      return q < 0 ? Math.ceil(q) || 0 : Math.floor(q);
    }, p: function(q) {
      return { M: E, y: h, w: g, d: w, D: C, h: i, m: l, s: a, ms: s, Q: d }[q] || String(q || "").toLowerCase().replace(/s$/, "");
    }, u: function(q) {
      return q === void 0;
    } }, L = "en", S = {};
    S[L] = b;
    var x = "$isDayjsObject", K = function(q) {
      return q instanceof ne || !(!q || !q[x]);
    }, Y = function q(M, $, V) {
      var D;
      if (!M) return L;
      if (typeof M == "string") {
        var G = M.toLowerCase();
        S[G] && (D = G), $ && (S[G] = $, D = G);
        var j = M.split("-");
        if (!D && j.length > 1) return q(j[0]);
      } else {
        var J = M.name;
        S[J] = M, D = J;
      }
      return !V && D && (L = D), D || !V && L;
    }, H = function(q, M) {
      if (K(q)) return q.clone();
      var $ = typeof M == "object" ? M : {};
      return $.date = q, $.args = arguments, new ne($);
    }, W = m;
    W.l = Y, W.i = K, W.w = function(q, M) {
      return H(q, { locale: M.$L, utc: M.$u, x: M.$x, $offset: M.$offset });
    };
    var ne = function() {
      function q($) {
        this.$L = Y($.locale, null, !0), this.parse($), this.$x = this.$x || $.x || {}, this[x] = !0;
      }
      var M = q.prototype;
      return M.parse = function($) {
        this.$d = function(V) {
          var D = V.date, G = V.utc;
          if (D === null) return /* @__PURE__ */ new Date(NaN);
          if (W.u(D)) return /* @__PURE__ */ new Date();
          if (D instanceof Date) return new Date(D);
          if (typeof D == "string" && !/Z$/i.test(D)) {
            var j = D.match(T);
            if (j) {
              var J = j[2] - 1 || 0, de = (j[7] || "0").substring(0, 3);
              return G ? new Date(Date.UTC(j[1], J, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, de)) : new Date(j[1], J, j[3] || 1, j[4] || 0, j[5] || 0, j[6] || 0, de);
            }
          }
          return new Date(D);
        }($), this.init();
      }, M.init = function() {
        var $ = this.$d;
        this.$y = $.getFullYear(), this.$M = $.getMonth(), this.$D = $.getDate(), this.$W = $.getDay(), this.$H = $.getHours(), this.$m = $.getMinutes(), this.$s = $.getSeconds(), this.$ms = $.getMilliseconds();
      }, M.$utils = function() {
        return W;
      }, M.isValid = function() {
        return this.$d.toString() !== p;
      }, M.isSame = function($, V) {
        var D = H($);
        return this.startOf(V) <= D && D <= this.endOf(V);
      }, M.isAfter = function($, V) {
        return H($) < this.startOf(V);
      }, M.isBefore = function($, V) {
        return this.endOf(V) < H($);
      }, M.$g = function($, V, D) {
        return W.u($) ? this[V] : this.set(D, $);
      }, M.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, M.valueOf = function() {
        return this.$d.getTime();
      }, M.startOf = function($, V) {
        var D = this, G = !!W.u(V) || V, j = W.p($), J = function(at, xe) {
          var Qe = W.w(D.$u ? Date.UTC(D.$y, xe, at) : new Date(D.$y, xe, at), D);
          return G ? Qe : Qe.endOf(w);
        }, de = function(at, xe) {
          return W.w(D.toDate()[at].apply(D.toDate("s"), (G ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(xe)), D);
        }, we = this.$W, ke = this.$M, Pe = this.$D, bt = "set" + (this.$u ? "UTC" : "");
        switch (j) {
          case h:
            return G ? J(1, 0) : J(31, 11);
          case E:
            return G ? J(1, ke) : J(0, ke + 1);
          case g:
            var st = this.$locale().weekStart || 0, lt = (we < st ? we + 7 : we) - st;
            return J(G ? Pe - lt : Pe + (6 - lt), ke);
          case w:
          case C:
            return de(bt + "Hours", 0);
          case i:
            return de(bt + "Minutes", 1);
          case l:
            return de(bt + "Seconds", 2);
          case a:
            return de(bt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, M.endOf = function($) {
        return this.startOf($, !1);
      }, M.$set = function($, V) {
        var D, G = W.p($), j = "set" + (this.$u ? "UTC" : ""), J = (D = {}, D[w] = j + "Date", D[C] = j + "Date", D[E] = j + "Month", D[h] = j + "FullYear", D[i] = j + "Hours", D[l] = j + "Minutes", D[a] = j + "Seconds", D[s] = j + "Milliseconds", D)[G], de = G === w ? this.$D + (V - this.$W) : V;
        if (G === E || G === h) {
          var we = this.clone().set(C, 1);
          we.$d[J](de), we.init(), this.$d = we.set(C, Math.min(this.$D, we.daysInMonth())).$d;
        } else J && this.$d[J](de);
        return this.init(), this;
      }, M.set = function($, V) {
        return this.clone().$set($, V);
      }, M.get = function($) {
        return this[W.p($)]();
      }, M.add = function($, V) {
        var D, G = this;
        $ = Number($);
        var j = W.p(V), J = function(ke) {
          var Pe = H(G);
          return W.w(Pe.date(Pe.date() + Math.round(ke * $)), G);
        };
        if (j === E) return this.set(E, this.$M + $);
        if (j === h) return this.set(h, this.$y + $);
        if (j === w) return J(1);
        if (j === g) return J(7);
        var de = (D = {}, D[l] = o, D[i] = r, D[a] = n, D)[j] || 1, we = this.$d.getTime() + $ * de;
        return W.w(we, this);
      }, M.subtract = function($, V) {
        return this.add(-1 * $, V);
      }, M.format = function($) {
        var V = this, D = this.$locale();
        if (!this.isValid()) return D.invalidDate || p;
        var G = $ || "YYYY-MM-DDTHH:mm:ssZ", j = W.z(this), J = this.$H, de = this.$m, we = this.$M, ke = D.weekdays, Pe = D.months, bt = D.meridiem, st = function(xe, Qe, vt, ct) {
          return xe && (xe[Qe] || xe(V, G)) || vt[Qe].slice(0, ct);
        }, lt = function(xe) {
          return W.s(J % 12 || 12, xe, "0");
        }, at = bt || function(xe, Qe, vt) {
          var ct = xe < 12 ? "AM" : "PM";
          return vt ? ct.toLowerCase() : ct;
        };
        return G.replace(f, function(xe, Qe) {
          return Qe || function(vt) {
            switch (vt) {
              case "YY":
                return String(V.$y).slice(-2);
              case "YYYY":
                return W.s(V.$y, 4, "0");
              case "M":
                return we + 1;
              case "MM":
                return W.s(we + 1, 2, "0");
              case "MMM":
                return st(D.monthsShort, we, Pe, 3);
              case "MMMM":
                return st(Pe, we);
              case "D":
                return V.$D;
              case "DD":
                return W.s(V.$D, 2, "0");
              case "d":
                return String(V.$W);
              case "dd":
                return st(D.weekdaysMin, V.$W, ke, 2);
              case "ddd":
                return st(D.weekdaysShort, V.$W, ke, 3);
              case "dddd":
                return ke[V.$W];
              case "H":
                return String(J);
              case "HH":
                return W.s(J, 2, "0");
              case "h":
                return lt(1);
              case "hh":
                return lt(2);
              case "a":
                return at(J, de, !0);
              case "A":
                return at(J, de, !1);
              case "m":
                return String(de);
              case "mm":
                return W.s(de, 2, "0");
              case "s":
                return String(V.$s);
              case "ss":
                return W.s(V.$s, 2, "0");
              case "SSS":
                return W.s(V.$ms, 3, "0");
              case "Z":
                return j;
            }
            return null;
          }(xe) || j.replace(":", "");
        });
      }, M.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, M.diff = function($, V, D) {
        var G, j = this, J = W.p(V), de = H($), we = (de.utcOffset() - this.utcOffset()) * o, ke = this - de, Pe = function() {
          return W.m(j, de);
        };
        switch (J) {
          case h:
            G = Pe() / 12;
            break;
          case E:
            G = Pe();
            break;
          case d:
            G = Pe() / 3;
            break;
          case g:
            G = (ke - we) / 6048e5;
            break;
          case w:
            G = (ke - we) / 864e5;
            break;
          case i:
            G = ke / r;
            break;
          case l:
            G = ke / o;
            break;
          case a:
            G = ke / n;
            break;
          default:
            G = ke;
        }
        return D ? G : W.a(G);
      }, M.daysInMonth = function() {
        return this.endOf(E).$D;
      }, M.$locale = function() {
        return S[this.$L];
      }, M.locale = function($, V) {
        if (!$) return this.$L;
        var D = this.clone(), G = Y($, V, !0);
        return G && (D.$L = G), D;
      }, M.clone = function() {
        return W.w(this.$d, this);
      }, M.toDate = function() {
        return new Date(this.valueOf());
      }, M.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, M.toISOString = function() {
        return this.$d.toISOString();
      }, M.toString = function() {
        return this.$d.toUTCString();
      }, q;
    }(), Je = ne.prototype;
    return H.prototype = Je, [["$ms", s], ["$s", a], ["$m", l], ["$H", i], ["$W", w], ["$M", E], ["$y", h], ["$D", C]].forEach(function(q) {
      Je[q[1]] = function(M) {
        return this.$g(M, q[0], q[1]);
      };
    }), H.extend = function(q, M) {
      return q.$i || (q(M, ne, H), q.$i = !0), H;
    }, H.locale = Y, H.isDayjs = K, H.unix = function(q) {
      return H(1e3 * q);
    }, H.en = S[L], H.Ls = S, H.p = {}, H;
  });
})(Oa);
var dd = Oa.exports;
const Pa = /* @__PURE__ */ xr(dd);
var Ia = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(s, a, l) {
      var i = a.prototype;
      l.utc = function(p) {
        var T = { date: p, utc: !0, args: arguments };
        return new a(T);
      }, i.utc = function(p) {
        var T = l(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? T.add(this.utcOffset(), n) : T;
      }, i.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var w = i.parse;
      i.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), w.call(this, p);
      };
      var g = i.init;
      i.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else g.call(this);
      };
      var E = i.utcOffset;
      i.utcOffset = function(p, T) {
        var f = this.$utils().u;
        if (f(p)) return this.$u ? 0 : f(this.$offset) ? E.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(L) {
          L === void 0 && (L = "");
          var S = L.match(o);
          if (!S) return null;
          var x = ("" + S[0]).match(r) || ["-", 0, 0], K = x[0], Y = 60 * +x[1] + +x[2];
          return Y === 0 ? 0 : K === "+" ? Y : -Y;
        }(p), p === null)) return this;
        var b = Math.abs(p) <= 16 ? 60 * p : p;
        if (b === 0) return this.utc(T);
        var A = this.clone();
        if (T) return A.$offset = b, A.$u = !1, A;
        var m = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (A = this.local().add(b + m, n)).$offset = b, A.$x.$localOffset = m, A;
      };
      var d = i.format;
      i.format = function(p) {
        var T = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, T);
      }, i.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, i.isUTC = function() {
        return !!this.$u;
      }, i.toISOString = function() {
        return this.toDate().toISOString();
      }, i.toString = function() {
        return this.toDate().toUTCString();
      };
      var h = i.toDate;
      i.toDate = function(p) {
        return p === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
      };
      var C = i.diff;
      i.diff = function(p, T, f) {
        if (p && this.$u === p.$u) return C.call(this, p, T, f);
        var b = this.local(), A = l(p).local();
        return C.call(b, A, T, f);
      };
    };
  });
})(Ia);
var md = Ia.exports;
const fd = /* @__PURE__ */ xr(md);
var Sa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(kr, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, o = {};
    return function(r, s, a) {
      var l, i = function(d, h, C) {
        C === void 0 && (C = {});
        var p = new Date(d), T = function(f, b) {
          b === void 0 && (b = {});
          var A = b.timeZoneName || "short", m = f + "|" + A, L = o[m];
          return L || (L = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: f, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: A }), o[m] = L), L;
        }(h, C);
        return T.formatToParts(p);
      }, w = function(d, h) {
        for (var C = i(d, h), p = [], T = 0; T < C.length; T += 1) {
          var f = C[T], b = f.type, A = f.value, m = n[b];
          m >= 0 && (p[m] = parseInt(A, 10));
        }
        var L = p[3], S = L === 24 ? 0 : L, x = p[0] + "-" + p[1] + "-" + p[2] + " " + S + ":" + p[4] + ":" + p[5] + ":000", K = +d;
        return (a.utc(x).valueOf() - (K -= K % 1e3)) / 6e4;
      }, g = s.prototype;
      g.tz = function(d, h) {
        d === void 0 && (d = l);
        var C, p = this.utcOffset(), T = this.toDate(), f = T.toLocaleString("en-US", { timeZone: d }), b = Math.round((T - new Date(f)) / 1e3 / 60), A = 15 * -Math.round(T.getTimezoneOffset() / 15) - b;
        if (!Number(A)) C = this.utcOffset(0, h);
        else if (C = a(f, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(A, !0), h) {
          var m = C.utcOffset();
          C = C.add(p - m, "minute");
        }
        return C.$x.$timezone = d, C;
      }, g.offsetName = function(d) {
        var h = this.$x.$timezone || a.tz.guess(), C = i(this.valueOf(), h, { timeZoneName: d }).find(function(p) {
          return p.type.toLowerCase() === "timezonename";
        });
        return C && C.value;
      };
      var E = g.startOf;
      g.startOf = function(d, h) {
        if (!this.$x || !this.$x.$timezone) return E.call(this, d, h);
        var C = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return E.call(C, d, h).tz(this.$x.$timezone, !0);
      }, a.tz = function(d, h, C) {
        var p = C && h, T = C || h || l, f = w(+a(), T);
        if (typeof d != "string") return a(d).tz(T);
        var b = function(S, x, K) {
          var Y = S - 60 * x * 1e3, H = w(Y, K);
          if (x === H) return [Y, x];
          var W = w(Y -= 60 * (H - x) * 1e3, K);
          return H === W ? [Y, H] : [S - 60 * Math.min(H, W) * 1e3, Math.max(H, W)];
        }(a.utc(d, p).valueOf(), f, T), A = b[0], m = b[1], L = a(A).utcOffset(m);
        return L.$x.$timezone = T, L;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(d) {
        l = d;
      };
    };
  });
})(Sa);
var wd = Sa.exports;
const pd = /* @__PURE__ */ xr(wd);
Pa.extend(fd);
Pa.extend(pd);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function $a(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function hd(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Is(e, t) {
  return e.get($a(e, t));
}
function gd(e, t, n) {
  hd(e, t), t.set(e, n);
}
function bd(e, t, n) {
  return e.set($a(e, t), n), n;
}
const vd = 100, F = {}, yd = () => {
  F.previousActiveElement instanceof HTMLElement ? (F.previousActiveElement.focus(), F.previousActiveElement = null) : document.body && document.body.focus();
}, _d = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  F.restoreFocusTimeout = setTimeout(() => {
    yd(), t();
  }, vd), window.scrollTo(n, o);
}), Da = "swal2-", Ed = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], v = Ed.reduce(
  (e, t) => (e[t] = Da + t, e),
  /** @type {SwalClasses} */
  {}
), kd = ["success", "warning", "info", "question", "error"], no = kd.reduce(
  (e, t) => (e[t] = Da + t, e),
  /** @type {SwalIcons} */
  {}
), Ma = "SweetAlert2:", Cr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Me = (e) => {
  console.warn(`${Ma} ${typeof e == "object" ? e.join(" ") : e}`);
}, Zt = (e) => {
  console.error(`${Ma} ${e}`);
}, Ss = [], xd = (e) => {
  Ss.includes(e) || (Ss.push(e), Me(e));
}, Ra = (e, t = null) => {
  xd(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, xo = (e) => typeof e == "function" ? e() : e, Ar = (e) => e && typeof e.toPromise == "function", Sn = (e) => Ar(e) ? e.toPromise() : Promise.resolve(e), Lr = (e) => e && Promise.resolve(e) === e, Be = () => document.body.querySelector(`.${v.container}`), $n = (e) => {
  const t = Be();
  return t ? t.querySelector(e) : null;
}, Ke = (e) => $n(`.${e}`), se = () => Ke(v.popup), hn = () => Ke(v.icon), Cd = () => Ke(v["icon-content"]), Ba = () => Ke(v.title), Tr = () => Ke(v["html-container"]), Fa = () => Ke(v.image), Nr = () => Ke(v["progress-steps"]), Co = () => Ke(v["validation-message"]), ht = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${v.actions} .${v.confirm}`)
), gn = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${v.actions} .${v.cancel}`)
), Jt = () => (
  /** @type {HTMLButtonElement} */
  $n(`.${v.actions} .${v.deny}`)
), Ad = () => Ke(v["input-label"]), bn = () => $n(`.${v.loader}`), Dn = () => Ke(v.actions), Ua = () => Ke(v.footer), Ao = () => Ke(v["timer-progress-bar"]), Or = () => Ke(v.close), Ld = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Pr = () => {
  const e = se();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const l = parseInt(s.getAttribute("tabindex") || "0"), i = parseInt(a.getAttribute("tabindex") || "0");
    return l > i ? 1 : l < i ? -1 : 0;
  }), o = e.querySelectorAll(Ld), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => He(s));
}, Ir = () => kt(document.body, v.shown) && !kt(document.body, v["toast-shown"]) && !kt(document.body, v["no-backdrop"]), Lo = () => {
  const e = se();
  return e ? kt(e, v.toast) : !1;
}, Td = () => {
  const e = se();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ge = (e, t) => {
  if (e.textContent = "", t) {
    const n = new DOMParser().parseFromString(t, "text/html"), o = n.querySelector("head");
    o && Array.from(o.childNodes).forEach((s) => {
      e.appendChild(s);
    });
    const r = n.querySelector("body");
    r && Array.from(r.childNodes).forEach((s) => {
      s instanceof HTMLVideoElement || s instanceof HTMLAudioElement ? e.appendChild(s.cloneNode(!0)) : e.appendChild(s);
    });
  }
}, kt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, Nd = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(v).includes(n) && !Object.values(no).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, qe = (e, t, n) => {
  if (Nd(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Me(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    oe(e, o);
  }
}, To = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${v.popup} > .${v[t]}`);
    case "checkbox":
      return e.querySelector(`.${v.popup} > .${v.checkbox} input`);
    case "radio":
      return e.querySelector(`.${v.popup} > .${v.radio} input:checked`) || e.querySelector(`.${v.popup} > .${v.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${v.popup} > .${v.range} input`);
    default:
      return e.querySelector(`.${v.popup} > .${v.input}`);
  }
}, Va = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ha = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, oe = (e, t) => {
  Ha(e, t, !0);
}, ot = (e, t) => {
  Ha(e, t, !1);
}, Tt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && kt(r, t))
      return r;
  }
}, qt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Ne = (e, t = "flex") => {
  e && (e.style.display = t);
}, $e = (e) => {
  e && (e.style.display = "none");
}, Sr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Mn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, $s = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Mn = (e, t, n = "flex") => {
  t ? Ne(e, n) : $e(e);
}, He = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Od = () => !He(ht()) && !He(Jt()) && !He(gn()), rr = (e) => e.scrollHeight > e.clientHeight, Pd = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (rr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, ja = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, $r = (e, t = !1) => {
  const n = Ao();
  n && He(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Id = () => {
  const e = Ao();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Sd = () => typeof window > "u" || typeof document > "u", $d = `
 <div aria-labelledby="${v.title}" aria-describedby="${v["html-container"]}" class="${v.popup}" tabindex="-1">
   <button type="button" class="${v.close}"></button>
   <ul class="${v["progress-steps"]}"></ul>
   <div class="${v.icon}"></div>
   <img class="${v.image}" />
   <h2 class="${v.title}" id="${v.title}"></h2>
   <div class="${v["html-container"]}" id="${v["html-container"]}"></div>
   <input class="${v.input}" id="${v.input}" />
   <input type="file" class="${v.file}" />
   <div class="${v.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${v.select}" id="${v.select}"></select>
   <div class="${v.radio}"></div>
   <label class="${v.checkbox}">
     <input type="checkbox" id="${v.checkbox}" />
     <span class="${v.label}"></span>
   </label>
   <textarea class="${v.textarea}" id="${v.textarea}"></textarea>
   <div class="${v["validation-message"]}" id="${v["validation-message"]}"></div>
   <div class="${v.actions}">
     <div class="${v.loader}"></div>
     <button type="button" class="${v.confirm}"></button>
     <button type="button" class="${v.deny}"></button>
     <button type="button" class="${v.cancel}"></button>
   </div>
   <div class="${v.footer}"></div>
   <div class="${v["timer-progress-bar-container"]}">
     <div class="${v["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Dd = () => {
  const e = Be();
  return e ? (e.remove(), ot([document.documentElement, document.body], [
    v["no-backdrop"],
    v["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    v["has-column"]
  ]), !0) : !1;
}, Ht = () => {
  F.currentInstance && F.currentInstance.resetValidationMessage();
}, Md = () => {
  const e = se();
  if (!e)
    return;
  const t = Tt(e, v.input), n = Tt(e, v.file), o = e.querySelector(`.${v.range} input`), r = e.querySelector(`.${v.range} output`), s = Tt(e, v.select), a = e.querySelector(`.${v.checkbox} input`), l = Tt(e, v.textarea);
  t && (t.oninput = Ht), n && (n.onchange = Ht), s && (s.onchange = Ht), a && (a.onchange = Ht), l && (l.oninput = Ht), o && r && (o.oninput = () => {
    Ht(), r.value = o.value;
  }, o.onchange = () => {
    Ht(), r.value = o.value;
  });
}, Rd = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Bd = (e) => {
  const t = se();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Fd = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (oe(Be(), v.rtl), F.isRTL = !0);
}, Ud = (e) => {
  const t = Dd();
  if (Sd()) {
    Zt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = v.container, t && oe(n, v["no-transition"]), Ge(n, $d), n.dataset.swal2Theme = e.theme;
  const o = Rd(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Bd(e), Fd(o), Md();
}, Dr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Vd(e, t) : e && Ge(t, e);
}, Vd = (e, t) => {
  "jquery" in e ? Hd(t, e) : Ge(t, e.toString());
}, Hd = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, jd = (e, t) => {
  const n = Dn(), o = bn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? $e(n) : Ne(n), qe(n, t, "actions"), Yd(n, o, t), Ge(o, t.loaderHtml || ""), qe(o, t, "loader"));
};
function Yd(e, t, n) {
  const o = ht(), r = Jt(), s = gn();
  !o || !r || !s || (jo(o, "confirm", n), jo(r, "deny", n), jo(s, "cancel", n), Wd(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Wd(e, t, n, o) {
  if (!o.buttonsStyling) {
    ot([e, t, n], v.styled);
    return;
  }
  oe([e, t, n], v.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Ho(e), Ho(t), Ho(n);
}
function Ho(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function jo(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Cr(t)
  );
  Mn(e, n[`show${o}Button`], "inline-block"), Ge(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = v[t], qe(e, n, `${t}Button`);
}
const qd = (e, t) => {
  const n = Or();
  n && (Ge(n, t.closeButtonHtml || ""), qe(n, t, "closeButton"), Mn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, zd = (e, t) => {
  const n = Be();
  n && (Kd(n, t.backdrop), Gd(n, t.position), Xd(n, t.grow), qe(n, t, "container"));
};
function Kd(e, t) {
  typeof t == "string" ? e.style.background = t : t || oe([document.documentElement, document.body], v["no-backdrop"]);
}
function Gd(e, t) {
  t && (t in v ? oe(e, v[t]) : (Me('The "position" parameter is not valid, defaulting to "center"'), oe(e, v.center)));
}
function Xd(e, t) {
  t && oe(e, v[`grow-${t}`]);
}
var ue = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Zd = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Jd = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = ue.innerParams.get(e), r = !o || t.input !== o.input;
  Zd.forEach((s) => {
    const a = Tt(n, v[s]);
    a && (tm(s, t.inputAttributes), a.className = v[s], r && $e(a));
  }), t.input && (r && Qd(t), nm(t));
}, Qd = (e) => {
  if (!e.input)
    return;
  if (!ge[e.input]) {
    Zt(`Unexpected type of input! Expected ${Object.keys(ge).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Ya(e.input);
  if (!t)
    return;
  const n = ge[e.input](t, e);
  Ne(t), e.inputAutoFocus && setTimeout(() => {
    Va(n);
  });
}, em = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, tm = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = To(n, e);
  if (o) {
    em(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, nm = (e) => {
  if (!e.input)
    return;
  const t = Ya(e.input);
  t && qe(t, e, "input");
}, Mr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Rn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = v["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && oe(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Ya = (e) => {
  const t = se();
  if (t)
    return Tt(t, v[
      /** @type {SwalClass} */
      e
    ] || v.input);
}, oo = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Lr(t) || Me(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, ge = {};
ge.text = ge.email = ge.password = ge.number = ge.tel = ge.url = ge.search = ge.date = ge["datetime-local"] = ge.time = ge.week = ge.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return oo(n, t.inputValue), Rn(n, n, t), Mr(n, t), n.type = /** @type {string} */
  t.input, n;
};
ge.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Rn(n, n, t), Mr(n, t), n;
};
ge.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (oo(o, t.inputValue), o.type = /** @type {string} */
  t.input, Rn(
    o,
    /** @type {Input} */
    e,
    t
  )), r && oo(r, t.inputValue), /** @type {Input} */
  e;
};
ge.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ge(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return Rn(n, n, t), n;
};
ge.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
ge.checkbox = (e, t) => {
  const n = se();
  if (!n)
    throw new Error("Popup not found");
  const o = To(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = (
    /** @type {HTMLElement} */
    e.querySelector("span")
  );
  if (r) {
    const s = t.inputPlaceholder || t.inputLabel;
    s && Ge(r, s);
  }
  return o;
};
ge.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  oo(n, t.inputValue), Mr(n, t), Rn(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = se();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const l = n.offsetWidth + o(n), i = se();
        i && (l > s ? i.style.width = `${l}px` : qt(i, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const om = (e, t) => {
  const n = Tr();
  n && (Sr(n), qe(n, t, "htmlContainer"), t.html ? (Dr(t.html, n), Ne(n, "block")) : t.text ? (n.textContent = t.text, Ne(n, "block")) : $e(n), Jd(e, t));
}, rm = (e, t) => {
  const n = Ua();
  n && (Sr(n), Mn(n, !!t.footer, "block"), t.footer && Dr(t.footer, n), qe(n, t, "footer"));
}, sm = (e, t) => {
  const n = ue.innerParams.get(e), o = hn();
  if (o) {
    if (n && t.icon === n.icon) {
      Ms(o, t), Ds(o, t);
      return;
    }
    if (!t.icon && !t.iconHtml) {
      $e(o);
      return;
    }
    if (t.icon && Object.keys(no).indexOf(t.icon) === -1) {
      Zt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), $e(o);
      return;
    }
    Ne(o), Ms(o, t), Ds(o, t), oe(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Wa);
  }
}, Ds = (e, t) => {
  for (const [n, o] of Object.entries(no))
    t.icon !== n && ot(e, o);
  oe(e, t.icon && no[t.icon]), lm(e, t), Wa(), qe(e, t, "icon");
}, Wa = () => {
  const e = se();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, am = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, im = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Ms = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Rs(t.iconHtml) : t.icon === "success" ? (o = am(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = im : t.icon && (o = Rs({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ge(e, o);
}, lm = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      $s(e, n, "background-color", t.iconColor);
    $s(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Rs = (e) => `<div class="${v["icon-content"]}">${e}</div>`, cm = (e, t) => {
  const n = Fa();
  if (n) {
    if (!t.imageUrl) {
      $e(n);
      return;
    }
    Ne(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), qt(n, "width", t.imageWidth), qt(n, "height", t.imageHeight), n.className = v.image, qe(n, t, "image");
  }
};
let Rr = !1, qa = 0, za = 0, Ka = 0, Ga = 0;
const um = (e) => {
  e.addEventListener("mousedown", ro), document.body.addEventListener("mousemove", so), e.addEventListener("mouseup", ao), e.addEventListener("touchstart", ro), document.body.addEventListener("touchmove", so), e.addEventListener("touchend", ao);
}, dm = (e) => {
  e.removeEventListener("mousedown", ro), document.body.removeEventListener("mousemove", so), e.removeEventListener("mouseup", ao), e.removeEventListener("touchstart", ro), document.body.removeEventListener("touchmove", so), e.removeEventListener("touchend", ao);
}, ro = (e) => {
  const t = se();
  if (!t)
    return;
  const n = hn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Rr = !0;
    const o = Xa(e);
    qa = o.clientX, za = o.clientY, Ka = parseInt(t.style.insetInlineStart) || 0, Ga = parseInt(t.style.insetBlockStart) || 0, oe(t, "swal2-dragging");
  }
}, so = (e) => {
  const t = se();
  if (t && Rr) {
    let {
      clientX: n,
      clientY: o
    } = Xa(e);
    const r = n - qa;
    t.style.insetInlineStart = `${Ka + (F.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${Ga + (o - za)}px`;
  }
}, ao = () => {
  const e = se();
  Rr = !1, ot(e, "swal2-dragging");
}, Xa = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, mm = (e, t) => {
  const n = Be(), o = se();
  if (!(!n || !o)) {
    if (t.toast) {
      qt(n, "width", t.width), o.style.width = "100%";
      const r = bn();
      r && o.insertBefore(r, hn());
    } else
      qt(o, "width", t.width);
    qt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), $e(Co()), fm(o, t), t.draggable && !t.toast ? (oe(o, v.draggable), um(o)) : (ot(o, v.draggable), dm(o));
  }
}, fm = (e, t) => {
  const n = t.showClass || {};
  e.className = `${v.popup} ${He(e) ? n.popup : ""}`, t.toast ? (oe([document.documentElement, document.body], v["toast-shown"]), oe(e, v.toast)) : oe(e, v.modal), qe(e, t, "popup"), typeof t.customClass == "string" && oe(e, t.customClass), t.icon && oe(e, v[`icon-${t.icon}`]);
}, wm = (e, t) => {
  const n = Nr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    $e(n);
    return;
  }
  Ne(n), n.textContent = "", r >= o.length && Me("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const l = pm(s);
    if (n.appendChild(l), a === r && oe(l, v["active-progress-step"]), a !== o.length - 1) {
      const i = hm(t);
      n.appendChild(i);
    }
  });
}, pm = (e) => {
  const t = document.createElement("li");
  return oe(t, v["progress-step"]), Ge(t, e), t;
}, hm = (e) => {
  const t = document.createElement("li");
  return oe(t, v["progress-step-line"]), e.progressStepsDistance && qt(t, "width", e.progressStepsDistance), t;
}, gm = (e, t) => {
  const n = Ba();
  n && (Sr(n), Mn(n, !!(t.title || t.titleText), "block"), t.title && Dr(t.title, n), t.titleText && (n.innerText = t.titleText), qe(n, t, "title"));
}, Za = (e, t) => {
  var n;
  mm(e, t), zd(e, t), wm(e, t), sm(e, t), cm(e, t), gm(e, t), qd(e, t), om(e, t), jd(e, t), rm(e, t);
  const o = se();
  typeof t.didRender == "function" && o && t.didRender(o), (n = F.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, bm = () => He(se()), Ja = () => {
  var e;
  return (e = ht()) === null || e === void 0 ? void 0 : e.click();
}, vm = () => {
  var e;
  return (e = Jt()) === null || e === void 0 ? void 0 : e.click();
}, ym = () => {
  var e;
  return (e = gn()) === null || e === void 0 ? void 0 : e.click();
}, vn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Qa = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, _m = (e, t, n) => {
  if (Qa(e), !t.toast) {
    const o = (s) => km(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : se();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, sr = (e, t) => {
  var n;
  const o = Pr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = se()) === null || n === void 0 || n.focus();
}, ei = ["ArrowRight", "ArrowDown"], Em = ["ArrowLeft", "ArrowUp"], km = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? xm(t, e) : t.key === "Tab" ? Cm(t) : [...ei, ...Em].includes(t.key) ? Am(t.key) : t.key === "Escape" && Lm(t, e, n)));
}, xm = (e, t) => {
  if (!xo(t.allowEnterKey))
    return;
  const n = se();
  if (!n || !t.input)
    return;
  const o = To(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Ja(), e.preventDefault();
  }
}, Cm = (e) => {
  const t = e.target, n = Pr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? sr(o, -1) : sr(o, 1), e.stopPropagation(), e.preventDefault();
}, Am = (e) => {
  const t = Dn(), n = ht(), o = Jt(), r = gn();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = ei.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let l = document.activeElement;
  if (l) {
    for (let i = 0; i < t.children.length; i++) {
      if (l = l[a], !l)
        return;
      if (l instanceof HTMLButtonElement && He(l))
        break;
    }
    l instanceof HTMLButtonElement && l.focus();
  }
}, Lm = (e, t, n) => {
  e.preventDefault(), xo(t.allowEscapeKey) && n(vn.esc);
};
var dn = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Tm = () => {
  const e = Be();
  Array.from(document.body.children).forEach((t) => {
    t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
  });
}, ti = () => {
  Array.from(document.body.children).forEach((e) => {
    e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
  });
}, ni = typeof window < "u" && !!window.GestureEvent, Nm = () => {
  if (ni && !kt(document.body, v.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, oe(document.body, v.iosfix), Om();
  }
}, Om = () => {
  const e = Be();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Pm(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Pm = (e) => {
  const t = e.target, n = Be(), o = Tr();
  return !n || !o || Im(e) || Sm(e) ? !1 : t === n || !rr(n) && t instanceof HTMLElement && !Pd(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(rr(o) && // #1944
  o.contains(t));
}, Im = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), Sm = (e) => e.touches && e.touches.length > 1, $m = () => {
  if (kt(document.body, v.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    ot(document.body, v.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Dm = () => {
  const e = document.createElement("div");
  e.className = v["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let an = null;
const Mm = (e) => {
  an === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (an = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${an + Dm()}px`);
}, Rm = () => {
  an !== null && (document.body.style.paddingRight = `${an}px`, an = null);
};
function oi(e, t, n, o) {
  Lo() ? Bs(e, o) : (_d(n).then(() => Bs(e, o)), Qa(F)), ni ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Ir() && (Rm(), $m(), ti()), Bm();
}
function Bm() {
  ot([document.documentElement, document.body], [v.shown, v["height-auto"], v["no-backdrop"], v["toast-shown"]]);
}
function Nt(e) {
  e = Um(e);
  const t = dn.swalPromiseResolve.get(this), n = Fm(this);
  this.isAwaitingPromise ? e.isDismissed || (Bn(this), t(e)) : n && t(e);
}
const Fm = (e) => {
  const t = se();
  if (!t)
    return !1;
  const n = ue.innerParams.get(e);
  if (!n || kt(t, n.hideClass.popup))
    return !1;
  ot(t, n.showClass.popup), oe(t, n.hideClass.popup);
  const o = Be();
  return ot(o, n.showClass.backdrop), oe(o, n.hideClass.backdrop), Vm(e, t, n), !0;
};
function ri(e) {
  const t = dn.swalPromiseReject.get(this);
  Bn(this), t && t(e);
}
const Bn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ue.innerParams.get(e) || e._destroy());
}, Um = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Vm = (e, t, n) => {
  var o;
  const r = Be(), s = ja(t);
  typeof n.willClose == "function" && n.willClose(t), (o = F.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? Hm(e, t, r, !!n.returnFocus, n.didClose) : r && oi(e, r, !!n.returnFocus, n.didClose);
}, Hm = (e, t, n, o, r) => {
  F.swalCloseEventFinishedCallback = oi.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var l;
      (l = F.swalCloseEventFinishedCallback) === null || l === void 0 || l.call(F), delete F.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Bs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = F.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, mn = (e) => {
  let t = se();
  if (t || new ir(), t = se(), !t)
    return;
  const n = bn();
  Lo() ? $e(hn()) : jm(t, e), Ne(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, jm = (e, t) => {
  const n = Dn(), o = bn();
  !n || !o || (!t && He(ht()) && (t = ht()), Ne(n), t && ($e(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), oe([e, n], v.loading));
}, Ym = (e, t) => {
  t.input === "select" || t.input === "radio" ? Gm(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Ar(t.inputValue) || Lr(t.inputValue)) && (mn(ht()), Xm(e, t));
}, Wm = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return qm(n);
    case "radio":
      return zm(n);
    case "file":
      return Km(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, qm = (e) => e.checked ? 1 : 0, zm = (e) => e.checked ? e.value : null, Km = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Gm = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Zm(n, io(r), t) : t.input === "radio" && Jm(n, io(r), t);
  };
  Ar(t.inputOptions) || Lr(t.inputOptions) ? (mn(ht()), Sn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Zt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Xm = (e, t) => {
  const n = e.getInput();
  n && ($e(n), Sn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Ne(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Zt(`Error in inputValue promise: ${o}`), n.value = "", Ne(n), n.focus(), e.hideLoading();
  }));
};
function Zm(e, t, n) {
  const o = Tt(e, v.select);
  if (!o)
    return;
  const r = (s, a, l) => {
    const i = document.createElement("option");
    i.value = l, Ge(i, a), i.selected = si(l, n.inputValue), s.appendChild(i);
  };
  t.forEach((s) => {
    const a = s[0], l = s[1];
    if (Array.isArray(l)) {
      const i = document.createElement("optgroup");
      i.label = a, i.disabled = !1, o.appendChild(i), l.forEach((w) => r(i, w[1], w[0]));
    } else
      r(o, l, a);
  }), o.focus();
}
function Jm(e, t, n) {
  const o = Tt(e, v.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], l = s[1], i = document.createElement("input"), w = document.createElement("label");
    i.type = "radio", i.name = v.radio, i.value = a, si(a, n.inputValue) && (i.checked = !0);
    const g = document.createElement("span");
    Ge(g, l), g.className = v.label, w.appendChild(i), w.appendChild(g), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const io = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = io(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = io(o)), t.push([n, o]);
  }), t;
}, si = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), Qm = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.input ? ai(e, "confirm") : Fr(e, !0);
}, ef = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? ai(e, "deny") : Br(e, !1);
}, tf = (e, t) => {
  e.disableButtons(), t(vn.cancel);
}, ai = (e, t) => {
  const n = ue.innerParams.get(e);
  if (!n.input) {
    Zt(`The "input" parameter is needed to be set when using returnInputValueOn${Cr(t)}`);
    return;
  }
  const o = e.getInput(), r = Wm(e, n);
  n.inputValidator ? nf(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Br(e, r) : Fr(e, r);
}, nf = (e, t, n) => {
  const o = ue.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Sn(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Br(e, t) : Fr(e, t);
  });
}, Br = (e, t) => {
  const n = ue.innerParams.get(e);
  n.showLoaderOnDeny && mn(Jt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preDeny(t, n.validationMessage))).then((o) => {
    o === !1 ? (e.hideLoading(), Bn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof o > "u" ? t : o
      }
    );
  }).catch((o) => ii(e, o))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Fs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, ii = (e, t) => {
  e.rejectPromise(t);
}, Fr = (e, t) => {
  const n = ue.innerParams.get(e);
  n.showLoaderOnConfirm && mn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Sn(n.preConfirm(t, n.validationMessage))).then((o) => {
    He(Co()) || o === !1 ? (e.hideLoading(), Bn(e)) : Fs(e, typeof o > "u" ? t : o);
  }).catch((o) => ii(e, o))) : Fs(e, t);
};
function lo() {
  const e = ue.innerParams.get(this);
  if (!e)
    return;
  const t = ue.domCache.get(this);
  $e(t.loader), Lo() ? e.icon && Ne(hn()) : of(t), ot([t.popup, t.actions], v.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const of = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Ne(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Od() && $e(e.actions);
};
function li() {
  const e = ue.innerParams.get(this), t = ue.domCache.get(this);
  return t ? To(t.popup, e.input) : null;
}
function ci(e, t, n) {
  const o = ue.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function ui(e, t) {
  const n = se();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${v.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function di() {
  ci(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function mi() {
  ci(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function fi() {
  ui(this.getInput(), !1);
}
function wi() {
  ui(this.getInput(), !0);
}
function pi(e) {
  const t = ue.domCache.get(this), n = ue.innerParams.get(this);
  Ge(t.validationMessage, e), t.validationMessage.className = v["validation-message"], n.customClass && n.customClass.validationMessage && oe(t.validationMessage, n.customClass.validationMessage), Ne(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", v["validation-message"]), Va(o), oe(o, v.inputerror));
}
function hi() {
  const e = ue.domCache.get(this);
  e.validationMessage && $e(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), ot(t, v.inputerror));
}
const Ot = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, rf = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], sf = {
  allowEnterKey: void 0
}, af = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], gi = (e) => Object.prototype.hasOwnProperty.call(Ot, e), bi = (e) => rf.indexOf(e) !== -1, vi = (e) => sf[e], lf = (e) => {
  gi(e) || Me(`Unknown parameter "${e}"`);
}, cf = (e) => {
  af.includes(e) && Me(`The parameter "${e}" is incompatible with toasts`);
}, uf = (e) => {
  const t = vi(e);
  t && Ra(e, t);
}, yi = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Me('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Me(`Invalid theme "${e.theme}"`);
  for (const t in e)
    lf(t), e.toast && cf(t), uf(t);
};
function _i(e) {
  const t = Be(), n = se(), o = ue.innerParams.get(this);
  if (!n || kt(n, o.hideClass.popup)) {
    Me("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = df(e), s = Object.assign({}, o, r);
  yi(s), t && (t.dataset.swal2Theme = s.theme), Za(this, s), ue.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const df = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (bi(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Me(`Invalid parameter to update: ${n}`);
  }), t;
};
function Ei() {
  var e;
  const t = ue.domCache.get(this), n = ue.innerParams.get(this);
  if (!n) {
    ki(this);
    return;
  }
  t.popup && F.swalCloseEventFinishedCallback && (F.swalCloseEventFinishedCallback(), delete F.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = F.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), mf(this);
}
const mf = (e) => {
  ki(e), delete e.params, delete F.keydownHandler, delete F.keydownTarget, delete F.currentInstance;
}, ki = (e) => {
  e.isAwaitingPromise ? (Yo(ue, e), e.isAwaitingPromise = !0) : (Yo(dn, e), Yo(ue, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Yo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var ff = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Ei,
  close: Nt,
  closeModal: Nt,
  closePopup: Nt,
  closeToast: Nt,
  disableButtons: mi,
  disableInput: wi,
  disableLoading: lo,
  enableButtons: di,
  enableInput: fi,
  getInput: li,
  handleAwaitingPromise: Bn,
  hideLoading: lo,
  rejectPromise: ri,
  resetValidationMessage: hi,
  showValidationMessage: pi,
  update: _i
});
const wf = (e, t, n) => {
  e.toast ? pf(e, t, n) : (gf(t), bf(t), vf(e, t, n));
}, pf = (e, t, n) => {
  t.popup.onclick = () => {
    e && (hf(e) || e.timer || e.input) || n(vn.close);
  };
}, hf = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let co = !1;
const gf = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (co = !0);
    };
  };
}, bf = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (co = !0);
    };
  };
}, vf = (e, t, n) => {
  t.container.onclick = (o) => {
    if (co) {
      co = !1;
      return;
    }
    o.target === t.container && xo(e.allowOutsideClick) && n(vn.backdrop);
  };
}, yf = (e) => typeof e == "object" && e.jquery, Us = (e) => e instanceof Element || yf(e), _f = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Us(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || Us(r) ? t[n] = r : r !== void 0 && Zt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Ef(...e) {
  return new this(...e);
}
function kf(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const xf = () => F.timeout && F.timeout.getTimerLeft(), xi = () => {
  if (F.timeout)
    return Id(), F.timeout.stop();
}, Ci = () => {
  if (F.timeout) {
    const e = F.timeout.start();
    return $r(e), e;
  }
}, Cf = () => {
  const e = F.timeout;
  return e && (e.running ? xi() : Ci());
}, Af = (e) => {
  if (F.timeout) {
    const t = F.timeout.increase(e);
    return $r(t, !0), t;
  }
}, Lf = () => !!(F.timeout && F.timeout.isRunning());
let Vs = !1;
const ar = {};
function Tf(e = "data-swal-template") {
  ar[e] = this, Vs || (document.body.addEventListener("click", Nf), Vs = !0);
}
const Nf = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in ar) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        ar[n].fire({
          template: o
        });
        return;
      }
    }
};
class Of {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
F.eventEmitter = new Of();
const Pf = (e, t) => {
  F.eventEmitter && F.eventEmitter.on(e, t);
}, If = (e, t) => {
  F.eventEmitter && F.eventEmitter.once(e, t);
}, Sf = (e, t) => {
  if (F.eventEmitter) {
    if (!e) {
      F.eventEmitter.reset();
      return;
    }
    t ? F.eventEmitter.removeListener(e, t) : F.eventEmitter.removeAllListeners(e);
  }
};
var $f = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: _f,
  bindClickHandler: Tf,
  clickCancel: ym,
  clickConfirm: Ja,
  clickDeny: vm,
  enableLoading: mn,
  fire: Ef,
  getActions: Dn,
  getCancelButton: gn,
  getCloseButton: Or,
  getConfirmButton: ht,
  getContainer: Be,
  getDenyButton: Jt,
  getFocusableElements: Pr,
  getFooter: Ua,
  getHtmlContainer: Tr,
  getIcon: hn,
  getIconContent: Cd,
  getImage: Fa,
  getInputLabel: Ad,
  getLoader: bn,
  getPopup: se,
  getProgressSteps: Nr,
  getTimerLeft: xf,
  getTimerProgressBar: Ao,
  getTitle: Ba,
  getValidationMessage: Co,
  increaseTimer: Af,
  isDeprecatedParameter: vi,
  isLoading: Td,
  isTimerRunning: Lf,
  isUpdatableParameter: bi,
  isValidParameter: gi,
  isVisible: bm,
  mixin: kf,
  off: Sf,
  on: Pf,
  once: If,
  resumeTimer: Ci,
  showLoading: mn,
  stopTimer: xi,
  toggleTimer: Cf
});
class Df {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Ai = ["swal-title", "swal-html", "swal-footer"], Mf = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Yf(n), Object.assign(Rf(n), Bf(n), Ff(n), Uf(n), Vf(n), Hf(n), jf(n, Ai));
}, Rf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((n) => {
    Gt(n, ["name", "value"]);
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "boolean" ? t[o] = r !== "false" : o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "object" ? t[o] = JSON.parse(r) : t[o] = r);
  }), t;
}, Bf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((n) => {
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (t[o] = new Function(`return ${r}`)());
  }), t;
}, Ff = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((n) => {
    Gt(n, ["type", "color", "aria-label"]);
    const o = n.getAttribute("type");
    if (!(!o || !["confirm", "cancel", "deny"].includes(o))) {
      if (t[`${o}ButtonText`] = n.innerHTML, t[`show${Cr(o)}Button`] = !0, n.hasAttribute("color")) {
        const r = n.getAttribute("color");
        r !== null && (t[`${o}ButtonColor`] = r);
      }
      if (n.hasAttribute("aria-label")) {
        const r = n.getAttribute("aria-label");
        r !== null && (t[`${o}ButtonAriaLabel`] = r);
      }
    }
  }), t;
}, Uf = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Gt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, Vf = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Gt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Hf = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Gt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Gt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, jf = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Gt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, Yf = (e) => {
  const t = Ai.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Me(`Unrecognized element <${o}>`);
  });
}, Gt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Me([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Li = 10, Wf = (e) => {
  var t, n;
  const o = Be(), r = se();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = F.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const s = window.getComputedStyle(document.body).overflowY;
  if (Kf(o, r, e), setTimeout(() => {
    qf(o, r);
  }, Li), Ir() && (zf(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, s), Tm()), !Lo() && !F.previousActiveElement && (F.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const a = e.didOpen;
    setTimeout(() => a(r));
  }
  (n = F.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, uo = (e) => {
  const t = se();
  if (!t || e.target !== t)
    return;
  const n = Be();
  n && (t.removeEventListener("animationend", uo), t.removeEventListener("transitionend", uo), n.style.overflowY = "auto", ot(n, v["no-transition"]));
}, qf = (e, t) => {
  ja(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", uo), t.addEventListener("transitionend", uo)) : e.style.overflowY = "auto";
}, zf = (e, t, n) => {
  Nm(), t && n !== "hidden" && Mm(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Kf = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && oe(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ne(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && oe(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Li)) : Ne(t, "grid"), oe([document.documentElement, document.body], v.shown), n.heightAuto && n.backdrop && !n.toast && oe([document.documentElement, document.body], v["height-auto"]);
};
var Hs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Gf(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Hs.email), e.input === "url" && (e.inputValidator = Hs.url));
}
function Xf(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Me('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Zf(e) {
  Gf(e), e.showLoaderOnConfirm && !e.preConfirm && Me(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Xf(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Ud(e);
}
let mt;
var Kn = /* @__PURE__ */ new WeakMap();
class _e {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (gd(
      this,
      Kn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    mt = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, bd(Kn, this, this._main(mt.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (yi(Object.assign({}, n, t)), F.currentInstance) {
      const s = dn.swalPromiseResolve.get(F.currentInstance), {
        isAwaitingPromise: a
      } = F.currentInstance;
      F.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), Ir() && ti();
    }
    F.currentInstance = mt;
    const o = Qf(t, n);
    Zf(o), Object.freeze(o), F.timeout && (F.timeout.stop(), delete F.timeout), clearTimeout(F.restoreFocusTimeout);
    const r = ew(mt);
    return Za(mt, o), ue.innerParams.set(mt, o), Jf(mt, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return Is(Kn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Is(Kn, this).finally(t);
  }
}
const Jf = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  dn.swalPromiseResolve.set(e, o), dn.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    Qm(e);
  }, t.denyButton.onclick = () => {
    ef(e);
  }, t.cancelButton.onclick = () => {
    tf(e, s);
  }, t.closeButton.onclick = () => {
    s(vn.close);
  }, wf(n, t, s), _m(F, n, s), Ym(e, n), Wf(n), tw(F, n, s), nw(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Qf = (e, t) => {
  const n = Mf(e), o = Object.assign({}, Ot, t, n, e);
  return o.showClass = Object.assign({}, Ot.showClass, o.showClass), o.hideClass = Object.assign({}, Ot.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, ew = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        se()
      ),
      container: (
        /** @type {HTMLElement} */
        Be()
      ),
      actions: (
        /** @type {HTMLElement} */
        Dn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ht()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Jt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        gn()
      ),
      loader: (
        /** @type {HTMLElement} */
        bn()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Or()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Co()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Nr()
      )
    }
  );
  return ue.domCache.set(e, t), t;
}, tw = (e, t, n) => {
  const o = Ao();
  $e(o), t.timer && (e.timeout = new Df(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Ne(o), qe(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && $r(
      /** @type {number} */
      t.timer
    );
  })));
}, nw = (e, t) => {
  if (!t.toast) {
    if (!xo(t.allowEnterKey)) {
      Ra("allowEnterKey"), sw();
      return;
    }
    ow(e) || rw(e, t) || sr(-1, 1);
  }
}, ow = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && He(n))
      return n.focus(), !0;
  return !1;
}, rw = (e, t) => t.focusDeny && He(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && He(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && He(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, sw = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
_e.prototype.disableButtons = mi;
_e.prototype.enableButtons = di;
_e.prototype.getInput = li;
_e.prototype.disableInput = wi;
_e.prototype.enableInput = fi;
_e.prototype.hideLoading = lo;
_e.prototype.disableLoading = lo;
_e.prototype.showValidationMessage = pi;
_e.prototype.resetValidationMessage = hi;
_e.prototype.close = Nt;
_e.prototype.closePopup = Nt;
_e.prototype.closeModal = Nt;
_e.prototype.closeToast = Nt;
_e.prototype.rejectPromise = ri;
_e.prototype.update = _i;
_e.prototype._destroy = Ei;
Object.assign(_e, $f);
Object.keys(ff).forEach((e) => {
  _e[e] = function(...t) {
    if (mt && mt[e])
      return mt[e](...t);
  };
});
_e.DismissReason = vn;
_e.version = "11.26.17";
const ir = _e;
ir.default = ir;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const aw = (e) => {
  if (!/^\d{8}$/.test(e)) return !1;
  const t = [1, 2, 1, 2, 1, 2, 4, 1];
  let n = 0, o = 0;
  for (let r = 0; r < 8; r++) {
    const s = parseInt(e.charAt(r), 10) * t[r];
    if (s >= 10) {
      const a = Math.floor(s / 10), l = s % 10;
      r === 6 && a === 7 ? (n += 7, o += 8) : (n += a + l, o += a + l);
    } else
      n += s, o += s;
  }
  return n % 5 === 0 || o % 5 === 0;
}, iw = (e) => {
  let t = e.replace(/\D/g, "");
  t.length > 8 && (t = t.slice(0, 8));
  let n = "", o = !1;
  return t.length === 8 ? aw(t) ? o = !0 : n = "統編格式檢查錯誤，請確認號碼" : t.length > 0 && (n = `統編需為 8 位數字（目前已輸入 ${t.length} 碼）`), { value: t, error: n, isReady: o };
};
function lw(e) {
  const {
    paymentInfo: t,
    isLoading: n,
    paymentError: o,
    fetchPaymentInfoPaginated: r,
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: l
  } = ud(e), i = Ve(void 0), w = ea({
    currentPage: 1,
    totalPages: 1,
    limit: 10
  }), g = Ye(() => t.value ? Array.isArray(t.value) ? t.value : [t.value] : []), E = Ye(() => {
    let C = 0, p = 0, T = 0, f = 0;
    return g.value.forEach((b) => {
      const A = String(b.rtn_code);
      A === "1" ? (C += b.trade_amt ? Number(b.trade_amt) : 0, p++) : A === "0" ? T++ : f++;
    }), { totalAmount: C, successCount: p, pendingCount: T, failedCount: f };
  }), d = async (C = 1) => {
    try {
      const p = {
        page: C,
        limit: w.limit,
        rtn_code: i.value
      }, T = await r(p);
      w.currentPage = T.page, w.totalPages = T.total > 0 ? Math.ceil(T.total / T.limit) : 1;
    } catch {
    }
  };
  return {
    isLoading: n,
    paymentError: o,
    paymentsList: g,
    filterRtnCode: i,
    pagination: w,
    stats: E,
    loadPaymentInfo: d,
    changeFilter: async (C) => {
      i.value = C, await d(1);
    },
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: l
  };
}
const cw = { class: "w-full bg-linear-to-br from-blue-700 to-blue-800 p-6 rounded-3xl text-white shadow-xl" }, uw = { class: "text-blue-100 opacity-90 font-medium text-sm" }, dw = { class: "text-3xl sm:text-4xl font-black mt-2" }, mw = { class: "grid grid-cols-3 gap-2 text-center text-xs sm:text-sm" }, fw = { class: "bg-white/10 p-3 rounded-2xl" }, ww = { class: "text-blue-100 opacity-80" }, pw = { class: "text-lg font-bold mt-1" }, hw = { class: "bg-white/10 p-3 rounded-2xl" }, gw = { class: "text-blue-100 opacity-80" }, bw = { class: "text-lg font-bold mt-1" }, vw = { class: "bg-white/10 p-3 rounded-2xl" }, yw = { class: "text-blue-100 opacity-80" }, _w = { class: "text-lg font-bold mt-1" }, Ew = /* @__PURE__ */ $t({
  __name: "PaymentStats",
  props: {
    totalAmount: {},
    successCount: {},
    pendingCount: {},
    failedCount: {}
  },
  setup(e) {
    const { t } = Rt();
    return (n, o) => (X(), te("div", cw, [
      _("p", uw, I(P(t)("paymentStats.totalAmount")), 1),
      _("h2", dw, "$ " + I(e.totalAmount.toLocaleString()), 1),
      o[0] || (o[0] = _("hr", { class: "border-white opacity-20 my-4" }, null, -1)),
      _("div", mw, [
        _("div", fw, [
          _("p", ww, I(P(t)("paymentStats.success")), 1),
          _("p", pw, I(e.successCount) + " " + I(P(t)("paymentStats.countUnit")), 1)
        ]),
        _("div", hw, [
          _("p", gw, I(P(t)("paymentStats.processing")), 1),
          _("p", bw, I(e.pendingCount) + " " + I(P(t)("paymentStats.countUnit")), 1)
        ]),
        _("div", vw, [
          _("p", yw, I(P(t)("paymentStats.failed")), 1),
          _("p", _w, I(e.failedCount) + " " + I(P(t)("paymentStats.countUnit")), 1)
        ])
      ])
    ]));
  }
}), kw = { class: "w-full flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-gray-100 pb-4" }, xw = { class: "min-w-0 flex-1" }, Cw = { class: "text-xs text-gray-700 opacity-60 uppercase tracking-wider" }, Aw = { class: "font-mono font-bold text-gray-700 text-sm sm:text-base mt-0.5 break-all" }, Lw = {
  key: 0,
  class: "min-w-0 flex-1"
}, Tw = { class: "flex items-start" }, Nw = { class: "grid grid-cols-2 gap-4 text-sm border-b border-gray-100 pb-4" }, Ow = { class: "text-gray-700 opacity-60 text-xs" }, Pw = { class: "text-lg sm:text-xl font-black text-gray-700 mt-1" }, Iw = { class: "text-gray-700 opacity-60 text-xs" }, Sw = { class: "text-gray-700 font-medium mt-1 text-xs sm:text-sm" }, $w = { class: "text-xs text-gray-700 opacity-60 block mt-0.5" }, Dw = {
  key: 0,
  class: "bg-gray-50 rounded-2xl p-4"
}, Mw = { class: "flex items-center justify-between mb-2" }, Rw = { class: "text-xs font-bold text-gray-700 uppercase tracking-wider" }, Bw = { class: "text-xs bg-white text-gray-700 font-bold px-2 py-0.5 rounded-md border border-gray-200" }, Fw = { class: "flex flex-col gap-1.5" }, Uw = { class: "select-all break-all" }, Vw = {
  key: 1,
  class: "text-xs text-gray-700 font-medium bg-gray-50 p-3 rounded-2xl text-center"
}, Hw = {
  key: 2,
  class: "bg-blue-50/50 rounded-2xl p-4 border border-blue-100"
}, jw = { class: "flex items-center justify-between mb-3" }, Yw = {
  key: 0,
  class: "flex items-center gap-2"
}, Ww = { class: "text-xs font-bold text-blue-700 uppercase tracking-wider" }, qw = { class: "flex items-center gap-2" }, zw = ["href"], Kw = { class: "grid grid-cols-2 gap-y-3 gap-x-4 text-[11px]" }, Gw = { class: "text-gray-500 mb-0.5" }, Xw = { class: "font-mono font-bold text-gray-700" }, Zw = { class: "text-gray-500 mb-0.5" }, Jw = { class: "font-medium text-gray-700" }, Qw = { key: 0 }, ep = { class: "text-gray-500 mb-0.5" }, tp = { class: "font-mono font-bold text-gray-700" }, np = { key: 1 }, op = { class: "text-gray-500 mb-0.5" }, rp = { class: "font-bold text-gray-700" }, sp = { key: 2 }, ap = { class: "text-gray-500 mb-0.5" }, ip = { class: "font-mono font-bold text-gray-700" }, lp = {
  key: 0,
  class: "mt-3 pt-3 border-t border-red-100 flex flex-col gap-1"
}, cp = { class: "flex items-center gap-1.5 text-red-700" }, up = { class: "text-[10px] font-black uppercase tracking-wider" }, dp = { class: "text-[11px] text-red-600 font-medium" }, mp = {
  key: 0,
  class: "bg-red-50 px-1 py-0.5 rounded mr-1"
}, fp = /* @__PURE__ */ $t({
  __name: "PaymentCard",
  props: {
    payment: {}
  },
  emits: ["clickCard"],
  setup(e, { emit: t }) {
    const { t: n } = Rt(), o = e, r = t, s = {
      1: { text: n("paymentCard.statusSuccess"), className: "bg-green-100 text-green-700 border-green-200" },
      0: { text: n("paymentCard.statusPending"), className: "bg-gray-100 text-black border-blue-700" },
      "-1": { text: n("paymentCard.statusVoided"), className: "bg-yellow-100 text-red-700 border-yellow-700" },
      default: { text: n("paymentCard.statusFailed"), className: "bg-rose-100 text-red-700 border-rose-200" }
    }, a = {
      issued: n("paymentCard.invoiceStatusIssued"),
      voided: n("paymentCard.invoiceStatusVoided"),
      init: n("paymentCard.invoiceStatusInit"),
      cancelled: n("paymentCard.invoiceStatusCancelled"),
      failed: n("paymentCard.invoiceStatusFailed")
    }, l = {
      COUNTER: { text: n("paymentCard.checkoutCounter"), className: "bg-purple-50 text-purple-700 border-purple-200" },
      ONLINE: { text: n("paymentCard.checkoutOnline"), className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
      default: { text: n("paymentCard.checkoutUnknown"), className: "bg-gray-50 text-gray-600 border-gray-200" }
    }, i = Ye(() => String(o.payment.rtn_code) === "1"), w = Ye(() => {
      const d = String(o.payment.rtn_code);
      return d in s ? s[d] : s.default;
    }), g = Ye(() => {
      const d = o.payment.checkout_type;
      return d ? d in l ? l[d] : { text: d, className: l.default.className } : l.default;
    }), E = Ye(() => {
      var h;
      const d = (h = o.payment.invoice_transaction) == null ? void 0 : h.status;
      return d === "issued" ? "bg-blue-100 text-blue-700 border-blue-200" : d === "failed" ? "bg-red-100 text-red-700 border-red-200" : "bg-gray-100 text-gray-500 border-gray-200";
    });
    return (d, h) => {
      var C;
      return X(), te("div", {
        onClick: h[1] || (h[1] = (p) => r("clickCard", e.payment)),
        class: on([
          "bg-white rounded-3xl border border-gray-100 p-5 sm:p-6 shadow-sm hover:shadow-md transition-all duration-200 space-y-4",
          i.value ? "cursor-pointer hover:border-blue-300" : ""
        ])
      }, [
        _("div", kw, [
          _("div", xw, [
            _("p", Cw, I(P(n)("paymentCard.transactionNo")), 1),
            _("p", Aw, I(e.payment.merchant_trade_no), 1)
          ]),
          e.payment.checkout_type ? (X(), te("div", Lw, [
            _("span", {
              class: on([g.value.className, "px-2.5 py-1 rounded-lg text-xs font-semibold border whitespace-nowrap"])
            }, I(g.value.text), 3)
          ])) : Ue("", !0),
          _("div", Tw, [
            _("span", {
              class: on([w.value.className, "px-3 py-1.5 rounded-full text-xs font-black border whitespace-nowrap"])
            }, I(w.value.text), 3)
          ])
        ]),
        _("div", Nw, [
          _("div", null, [
            _("p", Ow, I(P(n)("paymentCard.transactionAmount")), 1),
            _("p", Pw, " $ " + I(e.payment.trade_amt ? Number(e.payment.trade_amt).toLocaleString() : "0"), 1)
          ]),
          _("div", null, [
            _("p", Iw, I(P(n)("paymentCard.createdAt")), 1),
            _("p", Sw, [
              Lt(I(e.payment.created_at ? new Date(e.payment.created_at).toLocaleDateString() : "-") + " ", 1),
              _("span", $w, I(e.payment.created_at ? new Date(e.payment.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit"
              }) : ""), 1)
            ])
          ])
        ]),
        (C = e.payment.order_ids) != null && C.length ? (X(), te("div", Dw, [
          _("div", Mw, [
            _("p", Rw, I(P(n)("paymentCard.associatedOrders")), 1),
            _("span", Bw, I(e.payment.order_ids.length) + " " + I(P(n)("paymentCard.ordersCount")), 1)
          ]),
          _("div", Fw, [
            (X(!0), te(In, null, fr(e.payment.order_ids, (p) => (X(), te("div", {
              key: p,
              class: "flex items-center gap-2 bg-white px-3 py-1.5 rounded-xl border border-gray-100 text-xs font-mono text-gray-700 shadow-xs"
            }, [
              h[2] || (h[2] = _("span", { class: "w-1.5 h-1.5 bg-blue-700 rounded-full shrink-0" }, null, -1)),
              _("span", Uw, I(p.slice(-3)), 1)
            ]))), 128))
          ])
        ])) : (X(), te("div", Vw, " ⚠️ " + I(P(n)("paymentCard.noRelatedOrders")), 1)),
        e.payment.invoice_transaction ? (X(), te("div", Hw, [
          _("div", jw, [
            e.payment.invoice_transaction.status === "issued" ? (X(), te("div", Yw, [
              h[3] || (h[3] = _("svg", {
                class: "w-4 h-4 text-blue-700",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1)),
              _("p", Ww, I(P(n)("paymentCard.invoiceIssued")), 1)
            ])) : Ue("", !0),
            _("div", qw, [
              _("span", {
                class: on([E.value, "px-2 py-0.5 rounded text-[10px] font-bold border"])
              }, I(a[e.payment.invoice_transaction.status] || P(n)("paymentCard.statusUnknown")), 3),
              e.payment.invoice_transaction.print_html ? (X(), te("a", {
                key: 0,
                href: e.payment.invoice_transaction.print_html,
                target: "_blank",
                onClick: h[0] || (h[0] = Tl(() => {
                }, ["stop"])),
                class: "text-[10px] bg-blue-700 text-white font-bold px-2 py-0.5 rounded hover:bg-blue-800 transition-colors"
              }, " 📄 " + I(P(n)("paymentCard.viewInvoice")), 9, zw)) : Ue("", !0)
            ])
          ]),
          _("div", Kw, [
            _("div", null, [
              _("p", Gw, I(P(n)("paymentCard.invoiceNo")), 1),
              _("p", Xw, I(e.payment.invoice_transaction.invoice_no), 1)
            ]),
            _("div", null, [
              _("p", Zw, I(P(n)("paymentCard.invoiceDate")), 1),
              _("p", Jw, I(e.payment.invoice_transaction.invoice_date ? new Date(e.payment.invoice_transaction.invoice_date).toLocaleDateString() : "-"), 1)
            ]),
            e.payment.invoice_transaction.customer_identifier ? (X(), te("div", Qw, [
              _("p", ep, I(P(n)("paymentCard.buyerUbn")), 1),
              _("p", tp, I(e.payment.invoice_transaction.customer_identifier), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.customer_name ? (X(), te("div", np, [
              _("p", op, I(P(n)("paymentCard.buyerName")), 1),
              _("p", rp, I(e.payment.invoice_transaction.customer_name), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.carrier_num ? (X(), te("div", sp, [
              _("p", ap, I(P(n)("paymentCard.carrierNum")), 1),
              _("p", ip, I(e.payment.invoice_transaction.carrier_num), 1)
            ])) : Ue("", !0)
          ]),
          e.payment.invoice_transaction.status === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), te("div", lp, [
            _("div", cp, [
              h[4] || (h[4] = _("svg", {
                class: "w-3.5 h-3.5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _("p", up, I(P(n)("paymentCard.creationFailedReason")), 1)
            ]),
            _("p", dp, [
              e.payment.invoice_transaction.error_code ? (X(), te("span", mp, "[" + I(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
              Lt(" " + I(e.payment.invoice_transaction.error_message), 1)
            ])
          ])) : Ue("", !0)
        ])) : Ue("", !0)
      ], 2);
    };
  }
});
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function Ti(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function wp(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function js(e, t) {
  return e.get(Ti(e, t));
}
function pp(e, t, n) {
  wp(e, t), t.set(e, n);
}
function hp(e, t, n) {
  return e.set(Ti(e, t), n), n;
}
const gp = 100, U = {}, bp = () => {
  U.previousActiveElement instanceof HTMLElement ? (U.previousActiveElement.focus(), U.previousActiveElement = null) : document.body && document.body.focus();
}, vp = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  U.restoreFocusTimeout = setTimeout(() => {
    bp(), t();
  }, gp), window.scrollTo(n, o);
}), Ni = "swal2-", yp = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], y = yp.reduce(
  (e, t) => (e[t] = Ni + t, e),
  /** @type {SwalClasses} */
  {}
), _p = ["success", "warning", "info", "question", "error"], mo = _p.reduce(
  (e, t) => (e[t] = Ni + t, e),
  /** @type {SwalIcons} */
  {}
), Oi = "SweetAlert2:", Ur = (e) => e.charAt(0).toUpperCase() + e.slice(1), Re = (e) => {
  console.warn(`${Oi} ${typeof e == "object" ? e.join(" ") : e}`);
}, Qt = (e) => {
  console.error(`${Oi} ${e}`);
}, Ys = [], Ep = (e) => {
  Ys.includes(e) || (Ys.push(e), Re(e));
}, Pi = (e, t = null) => {
  Ep(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, No = (e) => typeof e == "function" ? e() : e, Vr = (e) => e && typeof e.toPromise == "function", Fn = (e) => Vr(e) ? e.toPromise() : Promise.resolve(e), Hr = (e) => e && Promise.resolve(e) === e, kp = () => navigator.userAgent.includes("Firefox"), Fe = () => document.body.querySelector(`.${y.container}`), Un = (e) => {
  const t = Fe();
  return t ? t.querySelector(e) : null;
}, Xe = (e) => Un(`.${e}`), ae = () => Xe(y.popup), yn = () => Xe(y.icon), xp = () => Xe(y["icon-content"]), Ii = () => Xe(y.title), jr = () => Xe(y["html-container"]), Si = () => Xe(y.image), Yr = () => Xe(y["progress-steps"]), Oo = () => Xe(y["validation-message"]), gt = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${y.actions} .${y.confirm}`)
), _n = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${y.actions} .${y.cancel}`)
), en = () => (
  /** @type {HTMLButtonElement} */
  Un(`.${y.actions} .${y.deny}`)
), Cp = () => Xe(y["input-label"]), En = () => Un(`.${y.loader}`), Vn = () => Xe(y.actions), $i = () => Xe(y.footer), Po = () => Xe(y["timer-progress-bar"]), Wr = () => Xe(y.close), Ap = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, qr = () => {
  const e = ae();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const l = parseInt(s.getAttribute("tabindex") || "0"), i = parseInt(a.getAttribute("tabindex") || "0");
    return l > i ? 1 : l < i ? -1 : 0;
  }), o = e.querySelectorAll(Ap), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => je(s));
}, zr = () => xt(document.body, y.shown) && !xt(document.body, y["toast-shown"]) && !xt(document.body, y["no-backdrop"]), Io = () => {
  const e = ae();
  return e ? xt(e, y.toast) : !1;
}, Lp = () => {
  const e = ae();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ze = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), r = o.querySelector("head");
    r && Array.from(r.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const s = o.querySelector("body");
    s && Array.from(s.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, xt = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, Tp = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(y).includes(n) && !Object.values(mo).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, ze = (e, t, n) => {
  if (Tp(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Re(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    re(e, o);
  }
}, So = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${y.popup} > .${y[t]}`);
    case "checkbox":
      return e.querySelector(`.${y.popup} > .${y.checkbox} input`);
    case "radio":
      return e.querySelector(`.${y.popup} > .${y.radio} input:checked`) || e.querySelector(`.${y.popup} > .${y.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${y.popup} > .${y.range} input`);
    default:
      return e.querySelector(`.${y.popup} > .${y.input}`);
  }
}, Di = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Mi = (e, t, n) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((s) => {
    o.forEach((a) => {
      n ? s.classList.add(a) : s.classList.remove(a);
    });
  });
}, re = (e, t) => {
  Mi(e, t, !0);
}, rt = (e, t) => {
  Mi(e, t, !1);
}, Pt = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && xt(n, t))
), zt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Oe = (e, t = "flex") => {
  e && (e.style.display = t);
}, De = (e) => {
  e && (e.style.display = "none");
}, Kr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Hn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Ws = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Hn = (e, t, n = "flex") => {
  t ? Oe(e, n) : De(e);
}, je = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Np = () => !je(gt()) && !je(en()) && !je(_n()), lr = (e) => e.scrollHeight > e.clientHeight, Op = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (lr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Ri = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, Gr = (e, t = !1) => {
  const n = Po();
  n && je(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Pp = () => {
  const e = Po();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Ip = () => typeof window > "u" || typeof document > "u", Sp = `
 <div aria-labelledby="${y.title}" aria-describedby="${y["html-container"]}" class="${y.popup}" tabindex="-1">
   <button type="button" class="${y.close}"></button>
   <ul class="${y["progress-steps"]}"></ul>
   <div class="${y.icon}"></div>
   <img class="${y.image}" />
   <h2 class="${y.title}" id="${y.title}"></h2>
   <div class="${y["html-container"]}" id="${y["html-container"]}"></div>
   <input class="${y.input}" id="${y.input}" />
   <input type="file" class="${y.file}" />
   <div class="${y.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${y.select}" id="${y.select}"></select>
   <div class="${y.radio}"></div>
   <label class="${y.checkbox}">
     <input type="checkbox" id="${y.checkbox}" />
     <span class="${y.label}"></span>
   </label>
   <textarea class="${y.textarea}" id="${y.textarea}"></textarea>
   <div class="${y["validation-message"]}" id="${y["validation-message"]}"></div>
   <div class="${y.actions}">
     <div class="${y.loader}"></div>
     <button type="button" class="${y.confirm}"></button>
     <button type="button" class="${y.deny}"></button>
     <button type="button" class="${y.cancel}"></button>
   </div>
   <div class="${y.footer}"></div>
   <div class="${y["timer-progress-bar-container"]}">
     <div class="${y["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), $p = () => {
  const e = Fe();
  return e ? (e.remove(), rt([document.documentElement, document.body], [
    y["no-backdrop"],
    y["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    y["has-column"]
  ]), !0) : !1;
}, jt = () => {
  U.currentInstance && U.currentInstance.resetValidationMessage();
}, Dp = () => {
  const e = ae();
  if (!e)
    return;
  const t = Pt(e, y.input), n = Pt(e, y.file), o = e.querySelector(`.${y.range} input`), r = e.querySelector(`.${y.range} output`), s = Pt(e, y.select), a = e.querySelector(`.${y.checkbox} input`), l = Pt(e, y.textarea);
  t && (t.oninput = jt), n && (n.onchange = jt), s && (s.onchange = jt), a && (a.onchange = jt), l && (l.oninput = jt), o && r && (o.oninput = () => {
    jt(), r.value = o.value;
  }, o.onchange = () => {
    jt(), r.value = o.value;
  });
}, Mp = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Rp = (e) => {
  const t = ae();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, Bp = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (re(Fe(), y.rtl), U.isRTL = !0);
}, Fp = (e) => {
  const t = $p();
  if (Ip()) {
    Qt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = y.container, t && re(n, y["no-transition"]), Ze(n, Sp), n.dataset.swal2Theme = e.theme;
  const o = Mp(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Rp(e), Bp(o), Dp();
}, Xr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Up(e, t) : e && Ze(t, e);
}, Up = (e, t) => {
  "jquery" in e ? Vp(t, e) : Ze(t, e.toString());
}, Vp = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Hp = (e, t) => {
  const n = Vn(), o = En();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? De(n) : Oe(n), ze(n, t, "actions"), jp(n, o, t), Ze(o, t.loaderHtml || ""), ze(o, t, "loader"));
};
function jp(e, t, n) {
  const o = gt(), r = en(), s = _n();
  !o || !r || !s || (Wo(o, "confirm", n), Wo(r, "deny", n), Wo(s, "cancel", n), Yp(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Yp(e, t, n, o) {
  if (!o.buttonsStyling) {
    rt([e, t, n], y.styled);
    return;
  }
  re([e, t, n], y.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [n, "cancel", o.cancelButtonColor]].forEach(([s, a, l]) => {
    l && s.style.setProperty(`--swal2-${a}-button-background-color`, l), Wp(s);
  });
}
function Wp(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Wo(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Ur(t)
  );
  Hn(e, n[`show${o}Button`], "inline-block"), Ze(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = y[t], ze(e, n, `${t}Button`);
}
const qp = (e, t) => {
  const n = Wr();
  n && (Ze(n, t.closeButtonHtml || ""), ze(n, t, "closeButton"), Hn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, zp = (e, t) => {
  const n = Fe();
  n && (Kp(n, t.backdrop), Gp(n, t.position), Xp(n, t.grow), ze(n, t, "container"));
};
function Kp(e, t) {
  typeof t == "string" ? e.style.background = t : t || re([document.documentElement, document.body], y["no-backdrop"]);
}
function Gp(e, t) {
  t && (t in y ? re(e, y[t]) : (Re('The "position" parameter is not valid, defaulting to "center"'), re(e, y.center)));
}
function Xp(e, t) {
  t && re(e, y[`grow-${t}`]);
}
var le = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const Zp = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Jp = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = le.innerParams.get(e), r = !o || t.input !== o.input;
  Zp.forEach((s) => {
    const a = Pt(n, y[s]);
    a && (th(s, t.inputAttributes), a.className = y[s], r && De(a));
  }), t.input && (r && Qp(t), nh(t));
}, Qp = (e) => {
  if (!e.input)
    return;
  if (!be[e.input]) {
    Qt(`Unexpected type of input! Expected ${Object.keys(be).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Bi(e.input);
  if (!t)
    return;
  const n = be[e.input](t, e);
  Oe(t), e.inputAutoFocus && setTimeout(() => {
    Di(n);
  });
}, eh = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, th = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = So(n, e);
  if (o) {
    eh(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, nh = (e) => {
  if (!e.input)
    return;
  const t = Bi(e.input);
  t && ze(t, e, "input");
}, Zr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, jn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = y["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && re(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Bi = (e) => {
  const t = ae();
  if (t)
    return Pt(t, y[
      /** @type {SwalClass} */
      e
    ] || y.input);
}, fo = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Hr(t) || Re(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, be = {};
be.text = be.email = be.password = be.number = be.tel = be.url = be.search = be.date = be["datetime-local"] = be.time = be.week = be.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return fo(n, t.inputValue), jn(n, n, t), Zr(n, t), n.type = /** @type {string} */
  t.input, n;
};
be.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return jn(n, n, t), Zr(n, t), n;
};
be.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (fo(o, t.inputValue), o.type = /** @type {string} */
  t.input, jn(
    o,
    /** @type {Input} */
    e,
    t
  )), r && fo(r, t.inputValue), /** @type {Input} */
  e;
};
be.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ze(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return jn(n, n, t), n;
};
be.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
be.checkbox = (e, t) => {
  const n = ae();
  if (!n)
    throw new Error("Popup not found");
  const o = So(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const s = /** @type {HTMLElement} */ e.querySelector("span");
  if (s) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && Ze(s, a);
  }
  return o;
};
be.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  fo(n, t.inputValue), Zr(n, t), jn(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = ae();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const l = n.offsetWidth + o(n), i = ae();
        i && (l > s ? i.style.width = `${l}px` : zt(i, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const oh = (e, t) => {
  const n = jr();
  n && (Kr(n), ze(n, t, "htmlContainer"), t.html ? (Xr(t.html, n), Oe(n, "block")) : t.text ? (n.textContent = t.text, Oe(n, "block")) : De(n), Jp(e, t));
}, rh = (e, t) => {
  const n = $i();
  n && (Kr(n), Hn(n, !!t.footer, "block"), t.footer && Xr(t.footer, n), ze(n, t, "footer"));
}, sh = (e, t) => {
  const n = le.innerParams.get(e), o = yn();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    zs(o, t), qs(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    De(o);
    return;
  }
  if (t.icon && Object.keys(mo).indexOf(t.icon) === -1) {
    Qt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), De(o);
    return;
  }
  Oe(o), zs(o, t), qs(o, t), re(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Fi);
}, qs = (e, t) => {
  for (const [n, o] of Object.entries(mo))
    t.icon !== n && rt(e, o);
  re(e, t.icon && mo[t.icon]), lh(e, t), Fi(), ze(e, t, "icon");
}, Fi = () => {
  const e = ae();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, ah = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, ih = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, zs = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Ks(t.iconHtml) : t.icon === "success" ? (o = ah(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = ih : t.icon && (o = Ks({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ze(e, o);
}, lh = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Ws(e, n, "background-color", t.iconColor);
    Ws(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Ks = (e) => `<div class="${y["icon-content"]}">${e}</div>`, ch = (e, t) => {
  const n = Si();
  if (n) {
    if (!t.imageUrl) {
      De(n);
      return;
    }
    Oe(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), zt(n, "width", t.imageWidth), zt(n, "height", t.imageHeight), n.className = y.image, ze(n, t, "image");
  }
};
let Jr = !1, Ui = 0, Vi = 0, Hi = 0, ji = 0;
const uh = (e) => {
  e.addEventListener("mousedown", wo), document.body.addEventListener("mousemove", po), e.addEventListener("mouseup", ho), e.addEventListener("touchstart", wo), document.body.addEventListener("touchmove", po), e.addEventListener("touchend", ho);
}, dh = (e) => {
  e.removeEventListener("mousedown", wo), document.body.removeEventListener("mousemove", po), e.removeEventListener("mouseup", ho), e.removeEventListener("touchstart", wo), document.body.removeEventListener("touchmove", po), e.removeEventListener("touchend", ho);
}, wo = (e) => {
  const t = ae();
  if (!t)
    return;
  const n = yn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Jr = !0;
    const o = Yi(e);
    Ui = o.clientX, Vi = o.clientY, Hi = parseInt(t.style.insetInlineStart) || 0, ji = parseInt(t.style.insetBlockStart) || 0, re(t, "swal2-dragging");
  }
}, po = (e) => {
  const t = ae();
  if (t && Jr) {
    let {
      clientX: n,
      clientY: o
    } = Yi(e);
    const r = n - Ui;
    t.style.insetInlineStart = `${Hi + (U.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${ji + (o - Vi)}px`;
  }
}, ho = () => {
  const e = ae();
  Jr = !1, rt(e, "swal2-dragging");
}, Yi = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, mh = (e, t) => {
  const n = Fe(), o = ae();
  if (!(!n || !o)) {
    if (t.toast) {
      zt(n, "width", t.width), o.style.width = "100%";
      const r = En();
      r && o.insertBefore(r, yn());
    } else
      zt(o, "width", t.width);
    zt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), De(Oo()), fh(o, t), t.draggable && !t.toast ? (re(o, y.draggable), uh(o)) : (rt(o, y.draggable), dh(o));
  }
}, fh = (e, t) => {
  const n = t.showClass || {};
  e.className = `${y.popup} ${je(e) ? n.popup : ""}`, t.toast ? (re([document.documentElement, document.body], y["toast-shown"]), re(e, y.toast)) : re(e, y.modal), ze(e, t, "popup"), typeof t.customClass == "string" && re(e, t.customClass), t.icon && re(e, y[`icon-${t.icon}`]);
}, wh = (e, t) => {
  const n = Yr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    De(n);
    return;
  }
  Oe(n), n.textContent = "", r >= o.length && Re("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const l = ph(s);
    if (n.appendChild(l), a === r && re(l, y["active-progress-step"]), a !== o.length - 1) {
      const i = hh(t);
      n.appendChild(i);
    }
  });
}, ph = (e) => {
  const t = document.createElement("li");
  return re(t, y["progress-step"]), Ze(t, e), t;
}, hh = (e) => {
  const t = document.createElement("li");
  return re(t, y["progress-step-line"]), e.progressStepsDistance && zt(t, "width", e.progressStepsDistance), t;
}, gh = (e, t) => {
  const n = Ii();
  n && (Kr(n), Hn(n, !!(t.title || t.titleText), "block"), t.title && Xr(t.title, n), t.titleText && (n.innerText = t.titleText), ze(n, t, "title"));
}, Wi = (e, t) => {
  var n;
  mh(e, t), zp(e, t), wh(e, t), sh(e, t), ch(e, t), gh(e, t), qp(e, t), oh(e, t), Hp(e, t), rh(e, t);
  const o = ae();
  typeof t.didRender == "function" && o && t.didRender(o), (n = U.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, bh = () => je(ae()), qi = () => {
  var e;
  return (e = gt()) === null || e === void 0 ? void 0 : e.click();
}, vh = () => {
  var e;
  return (e = en()) === null || e === void 0 ? void 0 : e.click();
}, yh = () => {
  var e;
  return (e = _n()) === null || e === void 0 ? void 0 : e.click();
}, kn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), zi = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, _h = (e, t, n) => {
  if (zi(e), !t.toast) {
    const o = (s) => kh(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : ae();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, cr = (e, t) => {
  var n;
  const o = qr();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(kp() && o[e] instanceof HTMLIFrameElement)) : ((n = ae()) === null || n === void 0 || n.focus(), !0);
}, Ki = ["ArrowRight", "ArrowDown"], Eh = ["ArrowLeft", "ArrowUp"], kh = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? xh(t, e) : t.key === "Tab" ? Ch(t) : [...Ki, ...Eh].includes(t.key) ? Ah(t.key) : t.key === "Escape" && Lh(t, e, n)));
}, xh = (e, t) => {
  if (!No(t.allowEnterKey))
    return;
  const n = ae();
  if (!n || !t.input)
    return;
  const o = So(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    qi(), e.preventDefault();
  }
}, Ch = (e) => {
  const t = e.target, o = qr().findIndex((s) => s === t);
  let r = !0;
  e.shiftKey ? r = cr(o, -1) : r = cr(o, 1), e.stopPropagation(), r && e.preventDefault();
}, Ah = (e) => {
  const t = Vn(), n = gt(), o = en(), r = _n();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = Ki.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let l = document.activeElement;
  if (l) {
    for (let i = 0; i < t.children.length; i++) {
      if (l = l[a], !l)
        return;
      if (l instanceof HTMLButtonElement && je(l))
        break;
    }
    l instanceof HTMLButtonElement && l.focus();
  }
}, Lh = (e, t, n) => {
  e.preventDefault(), No(t.allowEscapeKey) && n(kn.esc);
};
var fn = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Th = () => {
  const e = Fe();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Gi = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Qr = typeof window < "u" && !!window.GestureEvent, Nh = Qr && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Oh = () => {
  if (Qr && !xt(document.body, y.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, re(document.body, y.iosfix), Ph();
  }
}, Ph = () => {
  const e = Fe();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Ih(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Ih = (e) => {
  const t = e.target, n = Fe(), o = jr();
  return !n || !o || Sh(e) || $h(e) ? !1 : t === n || !lr(n) && t instanceof HTMLElement && !Op(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(lr(o) && // #1944
  o.contains(t));
}, Sh = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), $h = (e) => e.touches && e.touches.length > 1, Dh = () => {
  if (xt(document.body, y.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    rt(document.body, y.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Mh = () => {
  const e = document.createElement("div");
  e.className = y["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let ln = null;
const Rh = (e) => {
  ln === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (ln = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${ln + Mh()}px`);
}, Bh = () => {
  ln !== null && (document.body.style.paddingRight = `${ln}px`, ln = null);
};
function Xi(e, t, n, o) {
  Io() ? Gs(e, o) : (vp(n).then(() => Gs(e, o)), zi(U)), Qr ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), zr() && (Bh(), Dh(), Gi()), Fh();
}
function Fh() {
  rt([document.documentElement, document.body], [y.shown, y["height-auto"], y["no-backdrop"], y["toast-shown"]]);
}
function It(e) {
  e = Vh(e);
  const t = fn.swalPromiseResolve.get(this), n = Uh(this);
  this.isAwaitingPromise ? e.isDismissed || (Yn(this), t(e)) : n && t(e);
}
const Uh = (e) => {
  const t = ae();
  if (!t)
    return !1;
  const n = le.innerParams.get(e);
  if (!n || xt(t, n.hideClass.popup))
    return !1;
  rt(t, n.showClass.popup), re(t, n.hideClass.popup);
  const o = Fe();
  return rt(o, n.showClass.backdrop), re(o, n.hideClass.backdrop), Hh(e, t, n), !0;
};
function Zi(e) {
  const t = fn.swalPromiseReject.get(this);
  Yn(this), t && t(e);
}
const Yn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, le.innerParams.get(e) || e._destroy());
}, Vh = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Hh = (e, t, n) => {
  var o;
  const r = Fe(), s = Ri(t);
  typeof n.willClose == "function" && n.willClose(t), (o = U.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? jh(e, t, r, !!n.returnFocus, n.didClose) : r && Xi(e, r, !!n.returnFocus, n.didClose);
}, jh = (e, t, n, o, r) => {
  U.swalCloseEventFinishedCallback = Xi.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var l;
      (l = U.swalCloseEventFinishedCallback) === null || l === void 0 || l.call(U), delete U.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Gs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = U.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, wn = (e) => {
  let t = ae();
  if (t || new Wt(), t = ae(), !t)
    return;
  const n = En();
  Io() ? De(yn()) : Yh(t, e), Oe(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Yh = (e, t) => {
  const n = Vn(), o = En();
  !n || !o || (!t && je(gt()) && (t = gt()), Oe(n), t && (De(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), re([e, n], y.loading));
}, Wh = (e, t) => {
  t.input === "select" || t.input === "radio" ? Xh(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Vr(t.inputValue) || Hr(t.inputValue)) && (wn(gt()), Zh(e, t));
}, qh = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return zh(n);
    case "radio":
      return Kh(n);
    case "file":
      return Gh(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, zh = (e) => e.checked ? 1 : 0, Kh = (e) => e.checked ? e.value : null, Gh = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Xh = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Jh(n, ur(r), t) : t.input === "radio" && Qh(n, ur(r), t);
  };
  Vr(t.inputOptions) || Hr(t.inputOptions) ? (wn(gt()), Fn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Qt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Zh = (e, t) => {
  const n = e.getInput();
  n && (De(n), Fn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Oe(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Qt(`Error in inputValue promise: ${o}`), n.value = "", Oe(n), n.focus(), e.hideLoading();
  }));
};
function Jh(e, t, n) {
  const o = Pt(e, y.select);
  if (!o)
    return;
  const r = (s, a, l) => {
    const i = document.createElement("option");
    i.value = l, Ze(i, a), i.selected = Ji(l, n.inputValue), s.appendChild(i);
  };
  t.forEach((s) => {
    const a = s[0], l = s[1];
    if (Array.isArray(l)) {
      const i = document.createElement("optgroup");
      i.label = a, i.disabled = !1, o.appendChild(i), l.forEach((w) => r(i, w[1], w[0]));
    } else
      r(o, l, a);
  }), o.focus();
}
function Qh(e, t, n) {
  const o = Pt(e, y.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], l = s[1], i = document.createElement("input"), w = document.createElement("label");
    i.type = "radio", i.name = y.radio, i.value = a, Ji(a, n.inputValue) && (i.checked = !0);
    const g = document.createElement("span");
    Ze(g, l), g.className = y.label, w.appendChild(i), w.appendChild(g), o.appendChild(w);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const ur = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, o]) => [n, typeof o == "object" ? ur(o) : o]), Ji = (e, t) => !!t && t != null && t.toString() === e.toString(), eg = (e) => {
  const t = le.innerParams.get(e);
  e.disableButtons(), t.input ? Qi(e, "confirm") : ts(e, !0);
}, tg = (e) => {
  const t = le.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Qi(e, "deny") : es(e, !1);
}, ng = (e, t) => {
  e.disableButtons(), t(kn.cancel);
}, Qi = (e, t) => {
  const n = le.innerParams.get(e);
  if (!n.input) {
    Qt(`The "input" parameter is needed to be set when using returnInputValueOn${Ur(t)}`);
    return;
  }
  const o = e.getInput(), r = qh(e, n);
  n.inputValidator ? og(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? es(e, r) : ts(e, r);
}, og = (e, t, n) => {
  const o = le.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Fn(o.inputValidator(t, o.validationMessage))).then((s) => {
    e.enableButtons(), e.enableInput(), s ? e.showValidationMessage(s) : n === "deny" ? es(e, t) : ts(e, t);
  });
}, es = (e, t) => {
  const n = le.innerParams.get(e);
  n.showLoaderOnDeny && wn(en()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Fn(n.preDeny(t, n.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), Yn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => el(e, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Xs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, el = (e, t) => {
  e.rejectPromise(t);
}, ts = (e, t) => {
  const n = le.innerParams.get(e);
  n.showLoaderOnConfirm && wn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Fn(n.preConfirm(t, n.validationMessage))).then((r) => {
    je(Oo()) || r === !1 ? (e.hideLoading(), Yn(e)) : Xs(e, typeof r > "u" ? t : r);
  }).catch((r) => el(e, r))) : Xs(e, t);
};
function go() {
  const e = le.innerParams.get(this);
  if (!e)
    return;
  const t = le.domCache.get(this);
  De(t.loader), Io() ? e.icon && Oe(yn()) : rg(t), rt([t.popup, t.actions], y.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const rg = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Oe(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Np() && De(e.actions);
};
function tl() {
  const e = le.innerParams.get(this), t = le.domCache.get(this);
  return t ? So(t.popup, e.input) : null;
}
function nl(e, t, n) {
  const o = le.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function ol(e, t) {
  const n = ae();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${y.radio}"]`).forEach((r) => {
    r.disabled = t;
  }) : e.disabled = t);
}
function rl() {
  nl(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = le.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), le.focusedElement.delete(this);
}
function sl() {
  le.focusedElement.set(this, document.activeElement), nl(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function al() {
  ol(this.getInput(), !1);
}
function il() {
  ol(this.getInput(), !0);
}
function ll(e) {
  const t = le.domCache.get(this), n = le.innerParams.get(this);
  Ze(t.validationMessage, e), t.validationMessage.className = y["validation-message"], n.customClass && n.customClass.validationMessage && re(t.validationMessage, n.customClass.validationMessage), Oe(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", y["validation-message"]), Di(o), re(o, y.inputerror));
}
function cl() {
  const e = le.domCache.get(this);
  e.validationMessage && De(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), rt(t, y.inputerror));
}
const St = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, sg = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], ag = {
  allowEnterKey: void 0
}, ig = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], ul = (e) => Object.prototype.hasOwnProperty.call(St, e), dl = (e) => sg.indexOf(e) !== -1, ml = (e) => ag[e], lg = (e) => {
  ul(e) || Re(`Unknown parameter "${e}"`);
}, cg = (e) => {
  ig.includes(e) && Re(`The parameter "${e}" is incompatible with toasts`);
}, ug = (e) => {
  const t = ml(e);
  t && Pi(e, t);
}, fl = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Re('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Re(`Invalid theme "${e.theme}"`);
  for (const t in e)
    lg(t), e.toast && cg(t), ug(t);
};
function wl(e) {
  const t = Fe(), n = ae(), o = le.innerParams.get(this);
  if (!n || xt(n, o.hideClass.popup)) {
    Re("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = dg(e), s = Object.assign({}, o, r);
  fl(s), t && (t.dataset.swal2Theme = s.theme), Wi(this, s), le.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const dg = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (dl(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Re(`Invalid parameter to update: ${n}`);
  }), t;
};
function pl() {
  var e;
  const t = le.domCache.get(this), n = le.innerParams.get(this);
  if (!n) {
    hl(this);
    return;
  }
  t.popup && U.swalCloseEventFinishedCallback && (U.swalCloseEventFinishedCallback(), delete U.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = U.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), mg(this);
}
const mg = (e) => {
  hl(e), delete e.params, delete U.keydownHandler, delete U.keydownTarget, delete U.currentInstance;
}, hl = (e) => {
  e.isAwaitingPromise ? (qo(le, e), e.isAwaitingPromise = !0) : (qo(fn, e), qo(le, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, qo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var fg = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: pl,
  close: It,
  closeModal: It,
  closePopup: It,
  closeToast: It,
  disableButtons: sl,
  disableInput: il,
  disableLoading: go,
  enableButtons: rl,
  enableInput: al,
  getInput: tl,
  handleAwaitingPromise: Yn,
  hideLoading: go,
  rejectPromise: Zi,
  resetValidationMessage: cl,
  showValidationMessage: ll,
  update: wl
});
const wg = (e, t, n) => {
  e.toast ? pg(e, t, n) : (gg(t), bg(t), vg(e, t, n));
}, pg = (e, t, n) => {
  t.popup.onclick = () => {
    e && (hg(e) || e.timer || e.input) || n(kn.close);
  };
}, hg = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let bo = !1;
const gg = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (bo = !0);
    };
  };
}, bg = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (bo = !0);
    };
  };
}, vg = (e, t, n) => {
  t.container.onclick = (o) => {
    if (bo) {
      bo = !1;
      return;
    }
    o.target === t.container && No(e.allowOutsideClick) && n(kn.backdrop);
  };
}, yg = (e) => typeof e == "object" && e !== null && "jquery" in e, Zs = (e) => e instanceof Element || yg(e), _g = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Zs(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || Zs(r) ? t[n] = r : r !== void 0 && Qt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function Eg(...e) {
  return new this(...e);
}
function kg(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const xg = () => U.timeout && U.timeout.getTimerLeft(), gl = () => {
  if (U.timeout)
    return Pp(), U.timeout.stop();
}, bl = () => {
  if (U.timeout) {
    const e = U.timeout.start();
    return Gr(e), e;
  }
}, Cg = () => {
  const e = U.timeout;
  return e && (e.running ? gl() : bl());
}, Ag = (e) => {
  if (U.timeout) {
    const t = U.timeout.increase(e);
    return Gr(t, !0), t;
  }
}, Lg = () => !!(U.timeout && U.timeout.isRunning());
let Js = !1;
const dr = {};
function Tg(e = "data-swal-template") {
  dr[e] = this, Js || (document.body.addEventListener("click", Ng), Js = !0);
}
const Ng = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in dr) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        dr[n].fire({
          template: o
        });
        return;
      }
    }
};
class Og {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
U.eventEmitter = new Og();
const Pg = (e, t) => {
  U.eventEmitter && U.eventEmitter.on(e, t);
}, Ig = (e, t) => {
  U.eventEmitter && U.eventEmitter.once(e, t);
}, Sg = (e, t) => {
  if (U.eventEmitter) {
    if (!e) {
      U.eventEmitter.reset();
      return;
    }
    t ? U.eventEmitter.removeListener(e, t) : U.eventEmitter.removeAllListeners(e);
  }
};
var $g = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: _g,
  bindClickHandler: Tg,
  clickCancel: yh,
  clickConfirm: qi,
  clickDeny: vh,
  enableLoading: wn,
  fire: Eg,
  getActions: Vn,
  getCancelButton: _n,
  getCloseButton: Wr,
  getConfirmButton: gt,
  getContainer: Fe,
  getDenyButton: en,
  getFocusableElements: qr,
  getFooter: $i,
  getHtmlContainer: jr,
  getIcon: yn,
  getIconContent: xp,
  getImage: Si,
  getInputLabel: Cp,
  getLoader: En,
  getPopup: ae,
  getProgressSteps: Yr,
  getTimerLeft: xg,
  getTimerProgressBar: Po,
  getTitle: Ii,
  getValidationMessage: Oo,
  increaseTimer: Ag,
  isDeprecatedParameter: ml,
  isLoading: Lp,
  isTimerRunning: Lg,
  isUpdatableParameter: dl,
  isValidParameter: ul,
  isVisible: bh,
  mixin: kg,
  off: Sg,
  on: Pg,
  once: Ig,
  resumeTimer: bl,
  showLoading: wn,
  stopTimer: gl,
  toggleTimer: Cg
});
class Dg {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const vl = ["swal-title", "swal-html", "swal-footer"], Mg = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Yg(n), Object.assign(Rg(n), Bg(n), Fg(n), Ug(n), Vg(n), Hg(n), jg(n, vl));
}, Rg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    Xt(o, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (r in St && typeof St[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "boolean" ? t[r] = s !== "false" : r in St && typeof St[
      /** @type {keyof typeof defaultParams} */
      r
    ] == "object" ? t[r] = JSON.parse(s) : t[r] = s);
  }), t;
}, Bg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (t[r] = new Function(`return ${s}`)());
  }), t;
}, Fg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    Xt(o, ["type", "color", "aria-label"]);
    const r = o.getAttribute("type");
    if (!r || !["confirm", "cancel", "deny"].includes(r))
      return;
    t[`${r}ButtonText`] = o.innerHTML, t[`show${Ur(r)}Button`] = !0;
    const s = o.getAttribute("color");
    s !== null && (t[`${r}ButtonColor`] = s);
    const a = o.getAttribute("aria-label");
    a !== null && (t[`${r}ButtonAriaLabel`] = a);
  }), t;
}, Ug = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    Xt(n, ["src", "width", "height", "alt"]);
    const o = n.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const r = n.getAttribute("width");
    r !== null && (t.imageWidth = r || void 0);
    const s = n.getAttribute("height");
    s !== null && (t.imageHeight = s || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, Vg = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Xt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Hg = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Xt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Xt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, jg = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Xt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, Yg = (e) => {
  const t = vl.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Re(`Unrecognized element <${o}>`);
  });
}, Xt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Re([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, yl = 10, Wg = (e) => {
  var t, n;
  const o = Fe(), r = ae();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = U.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Kg(o, r, e), setTimeout(() => {
    qg(o, r);
  }, yl), zr() && (zg(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), Th()), Nh && e.backdrop === !1 && r.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !Io() && !U.previousActiveElement && (U.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const l = e.didOpen;
    setTimeout(() => l(r));
  }
  (n = U.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, vo = (e) => {
  const t = ae();
  if (!t || e.target !== t)
    return;
  const n = Fe();
  n && (t.removeEventListener("animationend", vo), t.removeEventListener("transitionend", vo), n.style.overflowY = "auto", rt(n, y["no-transition"]));
}, qg = (e, t) => {
  Ri(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", vo), t.addEventListener("transitionend", vo)) : e.style.overflowY = "auto";
}, zg = (e, t, n) => {
  Oh(), t && n !== "hidden" && Rh(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Kg = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && re(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Oe(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && re(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, yl)) : Oe(t, "grid"), re([document.documentElement, document.body], y.shown), n.heightAuto && n.backdrop && !n.toast && re([document.documentElement, document.body], y["height-auto"]);
};
var Qs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Gg(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Qs.email), e.input === "url" && (e.inputValidator = Qs.url));
}
function Xg(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Re('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Zg(e) {
  Gg(e), e.showLoaderOnConfirm && !e.preConfirm && Re(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Xg(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Fp(e);
}
let ft;
var Gn = /* @__PURE__ */ new WeakMap();
class Ee {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (pp(
      this,
      Gn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    ft = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, hp(Gn, this, this._main(ft.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (fl(Object.assign({}, n, t)), U.currentInstance) {
      const s = fn.swalPromiseResolve.get(U.currentInstance), {
        isAwaitingPromise: a
      } = U.currentInstance;
      U.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), zr() && Gi();
    }
    U.currentInstance = ft;
    const o = Qg(t, n);
    Zg(o), Object.freeze(o), U.timeout && (U.timeout.stop(), delete U.timeout), clearTimeout(U.restoreFocusTimeout);
    const r = eb(ft);
    return Wi(ft, o), le.innerParams.set(ft, o), Jg(ft, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return js(Gn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return js(Gn, this).finally(t);
  }
}
const Jg = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  fn.swalPromiseResolve.set(e, o), fn.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    eg(e);
  }, t.denyButton.onclick = () => {
    tg(e);
  }, t.cancelButton.onclick = () => {
    ng(e, s);
  }, t.closeButton.onclick = () => {
    s(kn.close);
  }, wg(n, t, s), _h(U, n, s), Wh(e, n), Wg(n), tb(U, n, s), nb(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Qg = (e, t) => {
  const n = Mg(e), o = Object.assign({}, St, t, n, e);
  return o.showClass = Object.assign({}, St.showClass, o.showClass), o.hideClass = Object.assign({}, St.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, eb = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        ae()
      ),
      container: (
        /** @type {HTMLElement} */
        Fe()
      ),
      actions: (
        /** @type {HTMLElement} */
        Vn()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        gt()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        en()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        _n()
      ),
      loader: (
        /** @type {HTMLElement} */
        En()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Wr()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Oo()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Yr()
      )
    }
  );
  return le.domCache.set(e, t), t;
}, tb = (e, t, n) => {
  const o = Po();
  De(o), t.timer && (e.timeout = new Dg(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Oe(o), ze(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && Gr(
      /** @type {number} */
      t.timer
    );
  })));
}, nb = (e, t) => {
  if (!t.toast) {
    if (!No(t.allowEnterKey)) {
      Pi("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    ob(e) || rb(e, t) || cr(-1, 1);
  }
}, ob = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && je(n))
      return n.focus(), !0;
  return !1;
}, rb = (e, t) => t.focusDeny && je(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && je(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && je(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
Ee.prototype.disableButtons = sl;
Ee.prototype.enableButtons = rl;
Ee.prototype.getInput = tl;
Ee.prototype.disableInput = il;
Ee.prototype.enableInput = al;
Ee.prototype.hideLoading = go;
Ee.prototype.disableLoading = go;
Ee.prototype.showValidationMessage = ll;
Ee.prototype.resetValidationMessage = cl;
Ee.prototype.close = It;
Ee.prototype.closePopup = It;
Ee.prototype.closeModal = It;
Ee.prototype.closeToast = It;
Ee.prototype.rejectPromise = Zi;
Ee.prototype.update = wl;
Ee.prototype._destroy = pl;
Object.assign(Ee, $g);
Object.keys(fg).forEach((e) => {
  Ee[e] = function(...t) {
    if (ft && ft[e])
      return ft[e](...t);
  };
});
Ee.DismissReason = kn;
Ee.version = "11.26.25";
const Wt = Ee;
Wt.default = Wt;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const sb = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
}, ab = { class: "bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200" }, ib = { class: "p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50" }, lb = { class: "text-xl font-black text-gray-700" }, cb = { class: "p-6 space-y-5" }, ub = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-2xl p-4 flex flex-col gap-1"
}, db = { class: "flex items-center gap-1.5 text-red-700" }, mb = { class: "text-xs font-black uppercase tracking-wider" }, fb = { class: "text-sm text-red-600 font-medium" }, wb = {
  key: 0,
  class: "bg-red-100 px-1.5 py-0.5 rounded mr-1"
}, pb = { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, hb = { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, gb = { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, bb = ["placeholder"], vb = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, yb = { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, _b = { class: "relative" }, Eb = ["placeholder"], kb = {
  key: 0,
  class: "absolute right-3 top-1/2 -translate-y-1/2"
}, xb = { class: "p-6 bg-gray-50 flex gap-3" }, Cb = ["disabled"], Ab = ["disabled"], Lb = /* @__PURE__ */ $t({
  __name: "InvoiceModal",
  props: {
    isOpen: { type: Boolean },
    payment: {},
    queryCompanyName: { type: Function },
    createInvoice: { type: Function },
    voidPayment: { type: Function }
  },
  emits: ["close", "success"],
  setup(e, { emit: t }) {
    const { t: n } = Rt(), o = e, r = t, s = Ve(!1), a = Ve(!1), l = Ve(""), i = ea({
      CarrierNum: "",
      CustomerIdentifier: "",
      CustomerName: "",
      CustomerAddr: "台北市信義區忠孝東路五段",
      CustomerPhone: "0912345678",
      CustomerEmail: "test@example.com"
    });
    zo(() => o.isOpen, (d) => {
      d || (i.CarrierNum = "", i.CustomerIdentifier = "", i.CustomerName = "", l.value = "");
    });
    const w = async (d) => {
      const h = d.target, C = iw(h.value);
      if (h.value = C.value, i.CustomerIdentifier = C.value, l.value = C.error, C.isReady) {
        a.value = !0;
        try {
          const p = await o.queryCompanyName(C.value);
          p && p.Company_Name ? i.CustomerName = p.Company_Name : l.value = n("invoiceModal.companyNotFound");
        } catch {
          l.value = n("invoiceModal.queryNameFailed");
        } finally {
          a.value = !1;
        }
      }
    }, g = async () => {
      var d, h;
      if (o.payment) {
        if (i.CustomerIdentifier.length === 8 && !i.CustomerName.trim()) {
          Wt.fire({ title: n("invoiceModal.enterCustomerName"), timer: 1e3, showConfirmButton: !1 });
          return;
        }
        s.value = !0;
        try {
          const C = i.CustomerIdentifier.length === 8, p = {
            relate_number: o.payment.merchant_trade_no,
            customer_id: "",
            customer_addr: i.CustomerAddr,
            customer_phone: i.CustomerPhone,
            customer_email: i.CustomerEmail,
            print: i.CarrierNum ? "0" : "1",
            donation: "0",
            carrier_type: !C && i.CarrierNum ? "3" : "",
            carrier_num: C ? "" : i.CarrierNum,
            customer_identifier: i.CustomerIdentifier,
            customer_name: i.CustomerName || "消費者",
            tax_type: "1",
            sales_amount: Number(o.payment.trade_amt),
            items: [{
              item_name: "交易商品",
              item_count: 1,
              item_word: "件",
              item_price: Number(o.payment.trade_amt),
              item_amount: Number(o.payment.trade_amt)
            }]
          };
          await o.createInvoice(p), Wt.fire({ title: n("invoiceModal.invoiceCreatedSuccess"), timer: 1e3, showConfirmButton: !1 }), r("success");
        } catch (C) {
          Wt.fire({ title: `${n("invoiceModal.invoiceCreateFailed")}: ${((h = (d = C.response) == null ? void 0 : d.data) == null ? void 0 : h.message) || C.message}`, icon: "error", timer: 3e3 });
        } finally {
          s.value = !1;
        }
      }
    }, E = async () => {
      var d, h;
      if (o.payment && confirm(n("invoiceModal.voidConfirm"))) {
        s.value = !0;
        try {
          await o.voidPayment({
            merchant_trade_no: o.payment.merchant_trade_no,
            ids: o.payment.order_ids || [],
            merchant_id: o.payment.merchant_id
          }), alert(n("invoiceModal.voidSuccess")), r("success");
        } catch (C) {
          Wt.fire({ title: `${n("invoiceModal.voidFailed")}: ${((h = (d = C.response) == null ? void 0 : d.data) == null ? void 0 : h.message) || C.message}`, icon: "error", timer: 3e3 });
        } finally {
          s.value = !1;
        }
      }
    };
    return (d, h) => {
      var C, p, T, f, b, A;
      return e.isOpen ? (X(), te("div", sb, [
        _("div", ab, [
          _("div", ib, [
            _("h3", lb, I(P(n)("invoiceModal.title")), 1),
            _("button", {
              onClick: h[0] || (h[0] = (m) => r("close")),
              class: "text-gray-400 hover:text-gray-600 transition-colors"
            }, [...h[5] || (h[5] = [
              _("svg", {
                class: "w-6 h-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])])
          ]),
          _("div", cb, [
            ((p = (C = e.payment) == null ? void 0 : C.invoice_transaction) == null ? void 0 : p.status) === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), te("div", ub, [
              _("div", db, [
                h[6] || (h[6] = _("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ], -1)),
                _("p", mb, I(P(n)("invoiceModal.lastFailed")), 1)
              ]),
              _("p", fb, [
                e.payment.invoice_transaction.error_code ? (X(), te("span", wb, "[" + I(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
                Lt(" " + I(e.payment.invoice_transaction.error_message), 1)
              ])
            ])) : Ue("", !0),
            _("div", null, [
              _("label", pb, I(P(n)("invoiceModal.carrierNum")), 1),
              Mo(_("input", {
                "onUpdate:modelValue": h[1] || (h[1] = (m) => i.CarrierNum = m),
                type: "text",
                maxlength: "8",
                placeholder: "/ABC1234",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 512), [
                [Ro, i.CarrierNum]
              ]),
              _("p", hb, I(P(n)("invoiceModal.carrierNumHint")), 1)
            ]),
            _("div", null, [
              _("label", gb, I(P(n)("invoiceModal.customerIdentifier")), 1),
              Mo(_("input", {
                "onUpdate:modelValue": h[2] || (h[2] = (m) => i.CustomerIdentifier = m),
                onInput: w,
                type: "text",
                maxlength: "8",
                placeholder: P(n)("invoiceModal.customerIdentifierPlaceholder"),
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 40, bb), [
                [Ro, i.CustomerIdentifier]
              ]),
              l.value ? (X(), te("p", vb, I(l.value), 1)) : Ue("", !0)
            ]),
            _("div", null, [
              _("label", yb, I(P(n)("invoiceModal.customerName")), 1),
              _("div", _b, [
                Mo(_("input", {
                  "onUpdate:modelValue": h[3] || (h[3] = (m) => i.CustomerName = m),
                  type: "text",
                  placeholder: P(n)("invoiceModal.customerNamePlaceholder"),
                  class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
                }, null, 8, Eb), [
                  [Ro, i.CustomerName]
                ]),
                a.value ? (X(), te("div", kb, [...h[7] || (h[7] = [
                  _("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-blue-700 border-t-transparent" }, null, -1)
                ])])) : Ue("", !0)
              ])
            ])
          ]),
          _("div", xb, [
            _("button", {
              onClick: h[4] || (h[4] = (m) => r("close")),
              class: "px-4 py-3 rounded-2xl border border-gray-200 text-gray-700 font-bold hover:bg-white transition-colors"
            }, I(P(n)("invoiceModal.cancel")), 1),
            _("button", {
              onClick: E,
              disabled: s.value,
              class: "flex-1 px-4 py-3 rounded-2xl border border-red-200 text-red-700 font-bold hover:bg-red-50 disabled:opacity-50 transition-all"
            }, I(s.value ? P(n)("invoiceModal.processing") : P(n)("invoiceModal.voidTransaction")), 9, Cb),
            _("button", {
              onClick: g,
              disabled: s.value || ((f = (T = e.payment) == null ? void 0 : T.invoice_transaction) == null ? void 0 : f.status) === "issued",
              class: "flex-1 px-4 py-3 rounded-2xl bg-blue-700 text-white font-bold hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-blue-700/20"
            }, I(s.value ? P(n)("invoiceModal.processing") : ((A = (b = e.payment) == null ? void 0 : b.invoice_transaction) == null ? void 0 : A.status) === "issued" ? P(n)("invoiceModal.invoiceIssued") : P(n)("invoiceModal.confirmCreate")), 9, Ab)
          ])
        ])
      ])) : Ue("", !0);
    };
  }
}), Tb = { class: "p-4 sm:p-6 max-w-3xl mx-auto bg-gray-100 min-h-screen" }, Nb = { class: "mb-6" }, Ob = { class: "text-2xl sm:text-3xl font-black text-gray-700" }, Pb = { class: "text-gray-700 mt-1 opacity-70 text-sm sm:text-base" }, Ib = { class: "mb-4 flex gap-2" }, Sb = ["disabled"], $b = {
  key: 0,
  class: "text-center py-20"
}, Db = { class: "mt-4 text-blue-700 font-bold" }, Mb = {
  key: 1,
  class: "bg-red-100 text-red-700 p-4 rounded-2xl border border-red-700 shadow-sm"
}, Rb = {
  key: 2,
  class: "flex flex-col gap-6"
}, Bb = { class: "flex flex-col sm:flex-row items-center justify-between gap-4 bg-white px-6 py-4 rounded-2xl border border-gray-100 shadow-xs mt-2" }, Fb = { class: "text-sm text-gray-500" }, Ub = { class: "font-bold text-blue-600" }, Vb = { class: "font-bold text-gray-800" }, Hb = { class: "flex items-center gap-3" }, jb = ["disabled"], Yb = ["disabled"], Wb = {
  key: 3,
  class: "text-center py-20 text-gray-700 bg-white rounded-3xl border border-gray-100 shadow-sm"
}, qb = { class: "mt-4 font-medium" }, Gb = /* @__PURE__ */ $t({
  __name: "EcpayPaymentPage",
  props: {
    ecpayApi: {}
  },
  setup(e) {
    const { t } = Rt(), n = e, {
      isLoading: o,
      paymentError: r,
      paymentsList: s,
      filterRtnCode: a,
      pagination: l,
      stats: i,
      loadPaymentInfo: w,
      changeFilter: g,
      createInvoice: E,
      queryCompanyName: d,
      voidPayment: h
    } = lw(n.ecpayApi), C = Ve(!1), p = Ve(null), T = (A) => {
      var m;
      String(A.rtn_code) === "1" && ((m = A.invoice_transaction) != null && m.print_html ? window.open(A.invoice_transaction.print_html, "_blank") : (p.value = A, C.value = !0));
    }, f = () => {
      C.value = !1, p.value = null;
    }, b = async () => {
      f(), await w(l.currentPage);
    };
    return mr(async () => {
      await w(1);
    }), (A, m) => (X(), te("div", Tb, [
      _("header", Nb, [
        _("h1", Ob, I(P(t)("ecpay.title") || "交易紀錄管理"), 1),
        _("p", Pb, I(P(t)("ecpay.subtitle") || "檢視您系統中的所有綠界付款單據"), 1)
      ]),
      _("div", Ib, [
        _("button", {
          onClick: m[0] || (m[0] = (L) => P(g)(void 0)),
          class: on(["px-4 py-2 rounded-xl font-bold text-sm transition-all", P(a) === void 0 ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, I(P(t)("ecpay.showAll")), 3),
        _("button", {
          onClick: m[1] || (m[1] = (L) => P(g)("-1")),
          class: on(["px-4 py-2 rounded-xl font-bold text-sm transition-all", P(a) === "-1" ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, I(P(t)("ecpay.showVoidOnly")), 3),
        _("button", {
          onClick: m[2] || (m[2] = (L) => P(w)(P(l).currentPage)),
          disabled: P(o),
          class: "px-4 py-2 rounded-xl font-bold text-sm transition-all bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
        }, [
          m[5] || (m[5] = _("svg", {
            class: "inline-block w-4 h-4 mr-1",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            })
          ], -1)),
          Lt(" " + I(P(t)("ecpay.refresh")), 1)
        ], 8, Sb)
      ]),
      P(o) ? (X(), te("div", $b, [
        m[6] || (m[6] = _("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        _("p", Db, I(P(t)("common.loading") || "載入資料中..."), 1)
      ])) : P(r) ? (X(), te("div", Mb, I(P(r)), 1)) : P(s).length > 0 ? (X(), te("div", Rb, [
        Ko(Ew, Nl(Ol(P(i))), null, 16),
        (X(!0), te(In, null, fr(P(s), (L) => (X(), Pl(fp, {
          key: L.id,
          payment: L,
          onClickCard: T
        }, null, 8, ["payment"]))), 128)),
        _("div", Bb, [
          _("p", Fb, [
            Lt(I(P(t)("ecpay.currentPage")) + " ", 1),
            _("span", Ub, I(P(l).currentPage), 1),
            Lt(" " + I(P(t)("ecpay.totalPages")) + " ", 1),
            _("span", Vb, I(P(l).totalPages), 1),
            Lt(" " + I(P(t)("ecpay.totalPages").includes("頁") ? "頁" : "pages"), 1)
          ]),
          _("div", Hb, [
            _("button", {
              disabled: P(l).currentPage <= 1,
              onClick: m[3] || (m[3] = (L) => P(w)(P(l).currentPage - 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, I(P(t)("ecpay.previousPage")), 9, jb),
            _("button", {
              disabled: P(l).currentPage >= P(l).totalPages,
              onClick: m[4] || (m[4] = (L) => P(w)(P(l).currentPage + 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, I(P(t)("ecpay.nextPage")), 9, Yb)
          ])
        ])
      ])) : (X(), te("div", Wb, [
        m[7] || (m[7] = _("svg", {
          class: "mx-auto h-12 w-12 text-gray-700",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })
        ], -1)),
        _("p", qb, I(P(t)("ecpay.noData") || "暫無任何交易紀錄"), 1)
      ])),
      Ko(Lb, {
        "is-open": C.value,
        payment: p.value,
        "query-company-name": P(d),
        "create-invoice": P(E),
        "void-payment": P(h),
        onClose: f,
        onSuccess: b
      }, null, 8, ["is-open", "payment", "query-company-name", "create-invoice", "void-payment"])
    ]));
  }
});
export {
  Gb as EcpayPaymentPage,
  Kb as RevenueReportPage
};
